// Note: Please use snake_case for the test IDs! Thank you!

export const CAROUSEL_ARROW_BUTTON_LEFT = 'carousel_arrow_button_left'

export const BANK_PANEL = 'bank_panel'
export const LATER_PANEL = 'later_panel'
export const EARLY_PANEL = 'early_panel'
export const CHECKING_PANEL = 'checking_panel'
export const EMERGENCY_SAVINGS_PANEL = 'emergency_savings_panel'

export const LEARN_MORE_BANK_BADGE = 'learn_more_checking_badge'
export const VERIFYING_BANK_BADGE = 'verifying_checking_badge'
export const VERIFY_BANK_BADGE = 'verify_checking_badge'
export const ADD_MONEY_BANK_BADGE = 'add_money_checking_badge'
export const GET_75_BANK_BADGE = 'get_75_checking_badge'
export const EXPLORE_BANK_BADGE = 'explore_checking_badge'
export const SET_UP_BANK_BADGE = 'start_spending_checking_badge'
export const REOPEN_BANK_BADGE = 'reopen_checking_badge'
export const CLOSED_BANK_BADGE = 'closed_checking_badge'
export const LOCKED_BANK_BADGE = 'locked_checking_badge'

export const SET_UP_LATER_BADGE = 'set_up_later_badge'
export const EXPLORE_LATER_BADGE = 'explore_later_badge'

export const SET_UP_EARLY_BADGE = 'set_up_early_badge'
export const EXPLORE_EARLY_BADGE = 'explore_early_badge'
export const SET_UP_INVEST_BADGE = 'set_up_invest_badge'

export const CURRENCY_INPUT_V1_CENTS = 'currency_input_cents'
export const CURRENCY_INPUT_V1_DOLLAR = 'currency_input_dollar'
export const CURRENCY_INPUT_V2 = 'currency_input'
export const UPDATE_AMOUNT_BUTTON = 'update_amount_button'
export const CONTINUE_TURNING_OFF_BUTTON = 'continue_turning_off_button'

export const FUNDING_SOURCE = 'funding_source'
export const LINKED_ACCOUNT = 'linked_account'
/** NOTE: This test ID is not snake_case. */
export const LINKED_ACCOUNT_LIST = 'linked-account-list'
/** NOTE: This test ID is not snake_case. */
export const LINKED_ACCOUNT_WARNING_TEXT = 'linked-account-warning-text'
/** NOTE: This test ID is not snake_case. */
export const LINKED_ACCOUNTS_PAGE = 'linked-accounts-page'
export const LINKED_ACCOUNTS_ADD_ANOTHER_ACCOUNT_BUTTON =
  'linked_accounts_page_link_another_account'
export const PAUSE_TRANSFERS_TOGGLE = 'transfers_toggle'
export const ROUNDUPS_TOGGLE = 'roundups_toggle'

/** RDV INPUTS */
export const LINKED_ACCOUNTS_RDV_AMOUNT_1 = 'linked_accounts_rdv_amount_1'
export const LINKED_ACCOUNTS_RDV_AMOUNT_2 = 'linked_accounts_rdv_amount_2'

export const SPINNER = 'spinner'
export const GET_DIRECT_DEPOSIT_FORM_BUTTON = 'get_direct_deposit_form_button'
export const EDIT_DIRECT_DEPOSIT_BUTTON = 'edit_direct_deposit_button'

export const ADD_EMPLOYER_BUTTON = 'add_employer_button'
export const EMPLOYER_LOGO = 'employer_logo'
export const EMPLOYER_LOGO_DEFAULT = 'employer_logo_default'
export const SEARCH_RESULT_ITEM = 'search_result_item'
export const WEBVIEW_ACTION_STRIP = 'webview_action_strip'
export const WEBVIEW_ACTION_STRIP_BACK = 'webview_action_strip_back'
export const WEBVIEW_ACTION_STRIP_CANCEL = 'webview_action_strip_cancel'

export const SEARCH_TERM_INPUT = 'search_term_input'
export const SEARCH_CLEAR_BUTTON = 'search_term_input'
export const REACT_PLAYER_VIDEO = 'react_player_video'

const spend_card_tracker = 'spend_card_tracker'
export const ACTIVATE_CARD_LINK = `${spend_card_tracker}_activate_card_link`
export const CONTACT_SUPPORT_LINK = `${spend_card_tracker}_contact_support_link`
export const TRACK_YOUR_CARD_LINK = `${spend_card_tracker}_track_your_card_link`
export const DELIVERED_PROGRESS_ICON = `${spend_card_tracker}_delivered_progress_icon`
export const DELIVERED_PROGRESS_LABEL = `${spend_card_tracker}_delivered_progress_label`
export const PROCESSED_PROGRESS_ICON = `${spend_card_tracker}_processed_progress_icon`
export const PROCESSED_PROGRESS_LABEL = `${spend_card_tracker}_processed_progress_label`
export const PROGRESS_BAR = `${spend_card_tracker}_progress_bar`
export const SHIPPED_PROGRESS_ICON = `${spend_card_tracker}_shipped_progress_icon`
export const SHIPPED_PROGRESS_LABEL = `${spend_card_tracker}_shipped_progress_label`
export const SPEND_CARD_TRACKING_LINK = `${spend_card_tracker}_tracking_link`

export const SEARCH_CONTAINER = 'search_container'
export const SEARCH_BOX_TRIGGER = 'search_box_trigger'
export const SEARCH_BOX_TERM = 'search_box_term'
export const SEARCH_BOX_CLEAR = 'search_box_clear'
export const SEARCH_BOX_CTA = 'search_box_cta'
export const SEARCH_BOX_IMG = 'search_box_img'

export const DOCUMENTS_AND_SETTINGS_STRIP = 'documents_and_settings_strip'
export const PAST_HERO_FILTER = 'past_hero_filter'

const spend_home_screen = 'spend_home_screen'
export const SPEND_HOME_SCREEN_BANNER_BALANCE = `${spend_home_screen}_banner_balance`
export const SPEND_HOME_SCREEN_BANNER_TOTAL_DEPOSITS = `${spend_home_screen}_banner_total_deposits`
export const SPEND_HOME_SCREEN_BANNER_TOTAL_DEBITS = `${spend_home_screen}_banner_total_debits`
export const SPEND_HOME_FDIC_DISCLOSURE_BUTTON = `${spend_home_screen}_fdic_disclosure_button`
export const SPEND_HOME_FDIC_LEARN_MORE_BUTTON = `${spend_home_screen}_fdic_learn_more_button`

const spend_transfer_screen = 'spend_transfer_screen'
export const SPEND_TRANSFER_SCREEN_REVIEW_BUTTON = `${spend_transfer_screen}_review_button`
export const SPEND_TRANSFER_SCREEN_TRANSFER_BUTTON = `${spend_transfer_screen}_transfer_button`
export const SPEND_TRANSFER_SCREEN_BUTTON_SPINNER = `${spend_transfer_screen}_button_spinner`
export const SPEND_TRANSFER_SCREEN_LOW_BALANCE_MODAL_AMOUNT = `${spend_transfer_screen}_low_balance_modal_amount`
export const SPEND_TRANSFER_SCREEN_MINI_BUTTON = `${spend_transfer_screen}_mini_button`
export const SPEND_TRANSFER_SCREEN_MODAL_DONE_BUTTON = `${spend_transfer_screen}_modal_done_button`
export const BUTTON = 'button'
export const BACK_BUTTON = 'back_button'
export const CHECKBOX = 'checkbox'
export const CHECKBOX_INPUT = 'checkbox_input'
export const TEXT_INPUT = 'text_input'
export const DROPDOWN = 'dropdown'
export const DROPDOWN_OPTION = 'dropdown_option'
export const DROPDOWN_OVERLAY = 'dropdown_overlay'
export const TOAST_NOTIFICATION = 'toast_notification'

const found_money = 'found_money'
export const FOUND_MONEY_SEARCH_BAR = `${found_money}_search_bar`
export const FOUND_MONEY_MOBILE_SEARCH_ICON = `${found_money}_mobile_search_icon`
export const FOUND_MONEY_SEARCH_INPUT = `${found_money}_search_input`
export const FOUND_MONEY_SEARCH_RESULT = `${found_money}_search_result`
export const FOUND_MONEY_SEARCH_RESULTS = `${found_money}_search_results`
export const FOUND_MONEY_SUMMARY_TOTAL = `${found_money}_summary_total`
export const FOUND_MONEY_SUMMARY_PENDING = `${found_money}_summary_pending`
export const FOUND_MONEY_REWARD = `${found_money}_reward`
export const FOUND_MONEY_PROMOTIONS_CAROUSEL = `${found_money}_promotions_carousel`
export const FOUND_MONEY_PROMOTIONS_CAROUSEL_ITEM = `${found_money}_promotions_carousel_item`
export const FOUND_MONEY_OFFER_CARD = `${found_money}_offer_card`
export const FOUND_MONEY_OFFER_GROUP_TITLE = `${found_money}_offer_group_title`
export const FOUND_MONEY_OFFER_DETAIL_LOGO = `${found_money}_offer_detail_logo`
export const FOUND_MONEY_OFFER_DETAIL_BACKGROUND_IMAGE = `${found_money}_offer_detail_background_image`
export const FOUND_MONEY_OFFER_DETAIL_NAME = `${found_money}_offer_detail_name`
export const FOUND_MONEY_OFFER_DETAIL_INVESTMENT = `${found_money}_offer_detail_investment`
export const FOUND_MONEY_OFFER_DETAIL_CTA = `${found_money}_offer_detail_cta`
export const FOUND_MONEY_OFFER_DETAIL_DETAILS_AND_EXCLUSIONS_HEADER = `${found_money}_offer_details_and_exclusions_header`
export const FOUND_MONEY_OFFER_DETAIL_DETAIL = `${found_money}_offer_detail_detail`
export const FOUND_MONEY_OFFER_DETAIL_CARD_CONTAINER = `${found_money}_offer_detail_card_container`
export const FOUND_MONEY_OFFER_DETAIL_EXCLUSION = `${found_money}_offer_detail_exclusion`
export const FOUND_MONEY_OFFER_DETAIL_LINKED_CARD = `${found_money}_offer_detail_linked_card`
export const FOUND_MONEY_OFFER_DETAIL_TERMS = `${found_money}_offer_detail_terms`
export const FOUND_MONEY_OFFER_DETAIL_BADGE = `${found_money}_offer_detail_badge`
export const FOUND_MONEY_OFFER_DETAIL_TERMS_AND_CONDITIONS = `${found_money}_offer_detail_terms_and_conditions`
export const FOUND_MONEY_OFFER_DETAIL_LINKED_CARD_ALERT = `${found_money}_offer_detail_linked_card_alert`
export const FOUND_MONEY_LEDGER_SECTION_HEADER = `${found_money}_ledger_section_header`
export const FOUND_MONEY_PENDING_INVESTMENTS = `${found_money}_pending_investments`
export const FOUND_MONEY_FULFILLED_INVESTMENTS = `${found_money}_fulfilled_investments`
export const NO_TRANSACTIONS_CARD = `${found_money}_no_investments`
export const FOUND_MONEY_LEDGER_BUTTON = `${found_money}_ledger_button`
export const FOUND_MONEY_MOBILE_LEDGER_BUTTON = `${found_money}_mobile_ledger_button`
export const CAROUSEL_CONTAINER = 'carousel_container'
export const FOUND_MONEY_OFFER_CAROUSEL = `${found_money}_offer_carousel`
export const FOUND_MONEY_OFFER_GROUP_VIEW_ALL = `${found_money}_offer_group_view_all`
export const FOUND_MONEY_OFFER_GROUP = `${found_money}_offer_group`
export const FOUND_MONEY_OFFER_CATEGORIES_BUTTON = `${found_money}_offer_categories_button`
export const FOUND_MONEY_OFFER_CATEGORIES = `${found_money}_offer_categories`
export const FOUND_MONEY_OFFER_CATEGORIES_LINK = `${found_money}_offer_categories_link`
export const FOUND_MONEY_OFFER_FAVORITES_LINK = `${found_money}_offer_favorites_button`
export const FOUND_MONEY_NO_FAVORITES_CARD = `${found_money}_no_favorites_card`
export const FOUND_MONEY_OFFER_SEARCH_OVERLAY = `${found_money}_offer_search_overlay`
export const FOUND_MONEY_OFFER_FAVORITES_BUTTON = `${found_money}_offer_favorites_button`
export const FOUND_MONEY_OFFER_FAVORITED_ICON = `${found_money}_offer_favorited_icon`
export const FOUND_MONEY_OFFER_UNFAVORITED_ICON = `${found_money}_offer_unfavorited_icon`
export const EARN_TOUR_BUTTON = 'earn_tour_button'
export const EARN_LEDGER_HERO = 'earn_ledger_hero'
export const EARN_RECENT_ACTIVITY_TOTAL_EARNINGS =
  'earn_recent_activity_total_earnings'
export const EARN_RECENT_ACTIVITY_TOTAL_REWARDS_MATCHED =
  'earn_recent_activity_total_rewards_matched'
export const EARN_RECENT_ACTIVITY_REWARDS_MATCH_DRAWER =
  'earn_recent_activity_rewards_match_drawer'
export const EARN_RECENT_ACTIVITY_REWARDS_MATCH_INFO =
  'earn_recent_activity_rewards_match_info'
export const EARN_RECENT_ACTIVITY_REWARDS_MATCH_LOCK =
  'earn_recent_activity_rewards_match_lock'
export const EARN_RECENT_ACTIVITY_HELP_CTA = 'earn_recent_activity_help_cta'
export const EARN_RECENT_ACTIVITY_HELP_POPOVER =
  'earn_recent_activity_help_popver'
export const EARN_RECENT_ACTIVITY_COMPLETED_REWARD_INFO_CTA =
  'earn_recent_activity_completed_rewards_info_cta'
export const EARN_RECENT_ACTIVITY_LINKED_INVESTMENT =
  'earn_recent_activity_linked_investment'
export const EARN_RECENT_ACTIVITY_FLOATING_CAROUSEL_LABEL =
  'earn_recent_activity_floating_carousel_label'
export const EARN_RECENT_ACTIVITY_FLOATING_CAROUSEL_REWARDS =
  'earn_recent_activity_floating_carousel_rewards'
export const EARN_RECENT_ACTIVITY_FLOATING_CAROUSEL_REWARD =
  'earn_recent_activity_floating_carousel_reward'
export const EARN_RECENT_ACTIVITY_UPGRADE_LINK =
  'earn_recent_activity_upgrade_link'
export const EARN_RECENT_ACTIVITY_REWARDS_MATCH_MODAL_ALERT =
  'earn_recent_activity_rewards_match_modal_alert'

export const EARN_UPGRADE_LANDER = 'earn_upgrade_lander'
export const EARN_UPGRADE_LANDER_UPGRADE_BUTTON =
  'earn_upgrade_lander_upgrade_button'
export const EARN_UGPRADE_DRAWER = 'earn_upgrade_drawer'
export const EARN_UPGRADE_DRAWER_TIER_PRICING =
  'earn_upgrade_drawer_tier_pricing'
export const EARN_UPGRADE_DRAWER_TIER_PRICING_CURRENT =
  'earn_upgrade_drawer_tier_pricing_current'
export const EARN_UPGRADE_DRAWER_TIER_PRICING_NEW =
  'earn_upgrade_drawer_tier_pricing_new'

export const DROPS_OFFER_OVERLAY_BANNER = 'drops_offer_overlay_banner'

const spend_as_primary = 'spend_as_primary'
export const SPEND_AS_PRIMARY_ACCOUNT_NAME_AND_NUMBER = `${spend_as_primary}_account_name_and_number`

const spend_transactions = 'spend_transactions'
export const SPEND_TRANSACTIONS_AVAILABLE_AMOUNT = `${spend_transactions}_available_amount`
export const SPEND_TRANSACTIONS_SPENT_LAST_30 = `${spend_transactions}_spent_last_30`
export const SPEND_TRANSACTIONS_DEPOSITED_LAST_30 = `${spend_transactions}_deposited_last_30`

const spend_reissues = 'spend_reissues'
export const SPEND_REISSUES_LOCK_CARD_MODAL_USER_NAME = `${spend_reissues}_lock_card_modal_user_name`
export const SPEND_REISSUES_LOCK_CARD_MODAL_CARD_NUMBER = `${spend_reissues}_lock_card_modal_card_number`
export const SPEND_REISSUES_ON_ITS_WAY_MODAL_DATE = `${spend_reissues}_on_its_way_modal_date`
export const SPEND_REISSUES_CONFIRM_ADDRESS_NAME = `${spend_reissues}_confirm_address_name`
export const SPEND_REISSUES_CONFIRM_ADDRESS1 = `${spend_reissues}_confirm_address1`
export const SPEND_REISSUES_CONFIRM_ADDRESS2 = `${spend_reissues}_confirm_address2`
export const SPEND_REISSUES_CONFIRM_ADDRESS_CITY_STATE_ZIP = `${spend_reissues}_confirm_address_city_state_zip`
export const SPEND_REISSUES_VALIDATION_ADDRESS1 = `${spend_reissues}_validation_address1`
export const SPEND_REISSUES_VALIDATION_ADDRESS2 = `${spend_reissues}_validation_address2`
export const SPEND_REISSUES_VALIDATION_CITY_STATE_ZIP = `${spend_reissues}_validation_city_state_zip`
export const SPEND_REISSUES_REQUESTED_ADDRESS1 = `${spend_reissues}_requested_address1`
export const SPEND_REISSUES_REQUESTED_ADDRESS2 = `${spend_reissues}_requested_address2`
export const SPEND_REISSUES_REQUESTED_CITY_STATE_ZIP = `${spend_reissues}_requested_city_state_zip`

const spend_settings = 'spend_settings'
export const SPEND_SETTINGS_UNLOCK_CARD_MODAL_USER_NAME = `${spend_settings}_unlock_card_modal_user_name`
export const SPEND_SETTINGS_UNLOCK_CARD_MODAL_CARD_NUMBER = `${spend_settings}_unlock_card_modal_card_number`
export const SPEND_SETTINGS_SHIPPING_ADDRESS_TILE = `${spend_settings}_shipping_address_tile`
export const SPEND_SETTINGS_LOCK_CARD_TILE = `${spend_settings}_lock_card_tile`
export const SPEND_SETTINGS_REPLACE_CARD_TILE = `${spend_settings}_replace_card_tile`
export const SPEND_SETTINGS_UPDATE_PIN_TILE = `${spend_settings}_update_pin_tile`
export const SPEND_SETTINGS_DIRECT_DEPOSIT_TILE = `${spend_settings}_direct_deposit_tile`
export const SPEND_SETTINGS_ACTIVATE_DEBIT_TILE = `${spend_settings}_activate_debit_tile`

export const PAYCHECK_SPLIT_WIDGET_LOADING = 'paycheck_split_widget_loading'

export const SMART_DEPOSIT_AF_CARD = 'smart_deposit_af_card'
export const SMART_DEPOSIT_BACK_BUTTON = 'smart_deposit_back_button'
export const SMART_DEPOSIT_FAQ_BUTTON = 'smart_deposit_faq_button'
export const SMART_DEPOSIT_GET_STARTED_BUTTON =
  'smart_deposit_get_started_button'
export const SMART_DEPOSIT_ESTIMATION_BUTTON = 'smart_deposit_estimation_button'
export const SMART_DEPOSIT_DISTRIBUTION_DEPOSIT_AMOUNT =
  'smart_deposit_distribution_deposit_amount'
export const SMART_DEPOSIT_DISTRIBUTION_ACCOUNT_ROW =
  'smart_deposit_distribution_account_row'
export const SMART_DEPOSIT_DISTRIBUTION_ACCOUNT_SLIDER =
  'smart_deposit_distribution_account_slider'
export const SMART_DEPOSIT_DISTRIBUTION_EDIT_BUTTON =
  'smart_deposit_distribution_edit_button'
export const SMART_DEPOSIT_DISTRIBUTION_EDIT_RESET_BUTTON =
  'smart_deposit_distribution_edit_reset_button'
export const SMART_DEPOSIT_DISTRIBUTION_EDIT_SAVE_BUTTON =
  'smart_deposit_distribution_edit_save_button'
export const SMART_DEPOSIT_DISTRIBUTION_REMAINING_AMOUNT =
  'smart_deposit_distribution_remaining_amount'
export const SMART_DEPOSIT_DISTRIBUTION_SUBMIT_BUTTON =
  'smart_deposit_distribution_submit_button'
export const SMART_DEPOSIT_SUCCESS_BUTTON = 'smart_deposit_success_button'
export const SMART_DEPOSIT_SUCCESS_DIRECT_DEPOSIT_BUTTON =
  'smart_deposit_success_button'
export const SMART_DEPOSIT_SET_UP = 'smart_deposit_set_up'

export const MONEY_HUB_AF_CARD = 'money_hub_af_card'
export const MONEY_HUB_DIRECT_DEPOSIT = 'money_hub_direct_deposit'
export const MONEY_HUB_RECURRING_DEPOSIT = 'money_hub_recurring_deposit'
export const MONEY_HUB_MONTHLY_TOTAL = 'money_hub_monthly_total'
export const MONEY_HUB_UPSELL_CARD = 'money_hub_upsell_card'

export const USER_DROPDOWN_BUTTON = 'user_dropdown_button'
export const USER_DROPDOWN_MENU = 'user_dropdown_menu'
export const MENU_SETTINGS_LINK = 'menu_settings_link'
export const MENU_MESSAGE_CENTER_LINK = 'menu_message_center_link'
export const MENU_INVITE_LINK = 'menu_invite_link'
export const MENU_REDEEM_LINK = 'menu_redeem_link'
export const MENU_ACCESSIBILITY_LINK = 'menu_accessibility_link'
export const LOGOUT = 'logout'
export const FUND_DETAILS_MARKET_VALUE = 'fund_details_market_value'
export const FUND_DETAILS_SHARES = 'fund_details_shares'
export const FUND_DETAILS_TODAYS_RETURN = 'fund_details_todays_return'
export const FUND_DETAILS_TOTAL_RETURN = 'fund_details_total_return'
export const FUND_DETAILS_MARKET_CAP = 'fund_details_market_cap'
export const FUND_DETAILS_SYMBOL = 'fund_details_symbol'
export const FUND_DETAILS_CURRENT_PRICE = 'fund_details_current_price'
export const FUND_DETAILS_VOLUME = 'fund_details_volume'
export const FUND_DETAILS_OPENING_PRICE = 'fund_details_opening_price'
export const FUND_DETAILS_PREVIOUS_OPENING_PRICE =
  'fund_details_previous_opening_price'
export const FUND_DETAILS_YEAR_RANGE = 'fund_details_year_range'
export const FUND_DETAILS_TAB = 'fund_details'
export const CUSTOM_VALUE = 'custom_value'
export const BASE_VALUE = 'base_value'
export const PORTFOLIO_WIDGET_TITLE = 'portfolio_widget_title'
export const PORTFOLIO_WIDGET_EXPANDER = 'portfolio_widget_expander'
export const PORTFOLIO_WIDGET_RISK = 'portfolio_widget_risk'
export const PORTFOLIO_WIDGET_THEME = 'portfolio_widget_theme'
export const PORTFOLIO_WIDGET_CONTAINER = 'portfolio_widget_container'
export const DOUGHNUT_CONTAINER = 'doughnut_container'
export const LANDER_HOW_IT_WORKS_BUTTON = 'lander_how_it_works_button'
export const LANDER_START_CUSTOMIZING_BUTTON = 'lander_start_customizing_button'
export const LANDER_COMPARE_TIERS_BUTTON = 'lander_compare_tiers_button'
export const LANDER_UPGRADE_BUTTON = 'lander_upgrade_button'
export const LANDER_UPGRADE_TIER_INCLUDES_ITEM =
  'lander_upgrade_tier_includes_item'
export const LANDER_UPGRADE_TIER_UPGRADE_BUTTON =
  'lander_upgrade_tier_upgrade_button'
export const LANDER_LEGACY_EARLY_TIER_BANNER = 'lander_legacy_early_tier_banner'
export const LANDER_LETS_GET_STARTED_CONTINUE_BUTTON =
  'lander_lets_get_started_continue_button'
export const HOW_IT_WORKS_TOUR_NEXT_BUTTON = 'carousel_next_button'
export const HOW_IT_WORKS_TOUR_ARROW_BUTTON_RIGHT =
  'carousel_arrow_button_right'
export const HOW_IT_WORKS_TOUR_ARROW_BUTTON_LEFT = 'carousel_arrow_button_left'
export const PORTFOLIO_BUILDER_SEARCH_RESULT = 'portfolio_builder_search_result'
export const PORTFOLIO_BUILDER_UNSAVED_CHANGES_MODAL =
  'portfolio_builder_unsaved_changes_modal'
export const PORTFOLIO_BUILDER_BASE_SECTION = 'portfolio_builder_base_section'
export const PORTFOLIO_BUILDER_BASE_LIST = 'portfolio_builder_base_list'
export const PORTFOLIO_BUILDER_BASE_CURRENT_PERCENTAGE =
  'portfolio_builder_base_current_percentage'
export const PORTFOLIO_BUILDER_BASE_SECURITY_NAME =
  'portfolio_builder_base_security_name'
export const PORTFOLIO_BUILDER_BASE_SECURITY_PERCENTAGE =
  'portfolio_builder_base_security_percentage'
export const PORTFOLIO_BUILDER_BASE_SECURITY_SYMBOL =
  'portfolio_builder_base_security_symbol'
export const PORTFOLIO_BUILDER_CUSTOM_SECTION =
  'portfolio_builder_custom_section'
export const PORTFOLIO_BUILDER_CUSTOM_LIST = 'portfolio_builder_custom_list'
export const PORTFOLIO_BUILDER_CUSTOM_CURRENT_PERCENTAGE =
  'portfolio_builder_custom_current_percentage'
export const PORTFOLIO_BUILDER_CUSTOM_MAX_PERCENTAGE =
  'portfolio_builder_custom_max_percentage'
export const PORTFOLIO_BUILDER_CUSTOM_SECURITY_NAME =
  'portfolio_builder_custom_security_name'
export const PORTFOLIO_BUILDER_CUSTOM_SECURITY_PERCENTAGE =
  'portfolio_builder_custom_security_percentage'
export const PORTFOLIO_BUILDER_CUSTOM_SECURITY_SYMBOL =
  'portfolio_builder_custom_security_symbol'
export const PORTFOLIO_BUILDER_CUSTOM_SECURITY_NAV_BUTTON =
  'portfolio_builder_custom_security_nav_button'
export const PORTFOLIO_BUILDER_SELF_DIRECTED_BUTTON =
  'portfolio_builder_self_directed_button'
export const PORTFOLIO_BUILDER_ADD_FIRST_SECURITY =
  'portfolio_builder_add_first_security'
export const PORTFOLIO_BUILDER_ADD_MORE_TO_CUSTOM =
  'portfolio_builder_add_more_to_custom'
export const PORTFOLIO_BUILDER_UPDATE_PORTFOLIO =
  'portfolio_builder_update_portfolio'
export const PORTFOLIO_BUILDER_UPDATED_CUSTOM_SECURITY_NAME =
  'portfolio_builder_updated_custom_security_name'
export const PORTFOLIO_BUILDER_UPDATED_CUSTOM_SECURITY_PERCENTAGE =
  'portfolio_builder_updated_custom_security_percentage'
export const PORTFOLIO_BUILDER_UPDATED_CUSTOM_SECURITY_SYMBOL =
  'portfolio_builder_updated_custom_security_symbol'
export const PORTFOLIO_BUILDER_BE_MINDFUL_TIP =
  'portfolio_builder_be_mindful_tip'
export const PORTFOLIO_UPDATE_CONFIRM_CUSTOMIZATION_FIRST_UPDATE_TEXT =
  'portfolio_update_confirm_customization_first_update_text'
export const PORTFOLIO_UPDATE_CONFIRM_CUSTOMIZATION_AFTER_FIRST_BUY =
  'portfolio_update_confirm_customization_after_first_buy'
export const PORTFOLIO_UPDATE_CONFIRM_CUSTOMIZATION_AFTER_FIRST_SELL =
  'portfolio_update_confirm_customization_after_first_sell'
export const PORTFOLIO_UPDATE_CONFIRM_CUSTOMIZATION_AFTER_FIRST_UPDATE =
  'portfolio_update_confirm_customization_after_first_update'
export const PORTFOLIO_UPDATE_NEXT_BUTTON = 'portfolio_update_next_button'
export const PORTFOLIO_UPDATE_SUCCESS_CUSTOM_CURRENT_PERCENTAGE =
  'portfolio_update_success_custom_current_percentage'
export const PORTFOLIO_UPDATE_SUCCESS_CUSTOM_SECURITY_PERCENTAGE =
  'portfolio_update_success_custom_security_percentage'
export const PORTFOLIO_UPDATE_SUCCESS_CUSTOM_SECURITY_SYMBOL =
  'portfolio_update_success_custom_security_symbol'
export const PORTFOLIO_UPDATE_SUCCESS_CUSTOM_SECURITY_NAME =
  'portfolio_update_success_custom_security_name'
export const PORTFOLIO_UPDATE_SUCCESS_BASE_CURRENT_PERCENTAGE =
  'portfolio_update_success_base_current_percentage'
export const CONFIRM_CUSTOMIZATION_BASE_PERCENTAGE =
  'confirm_customization_base_percentage'
export const CONFIRM_CUSTOMIZATION_CUSTOM_PERCENTAGE =
  'confirm_customization_custom_percentage'
export const MAX_ALLOCATION_MODAL_PERCENTAGE = 'max_allocation_modal_percentage'
export const MAX_ALLOCATION_MODAL_RISK_LEVEL = 'max_allocation_modal_risk_level'
export const LOADER_SPINNER = 'loader_spinner'
export const LOADER_UPDATING_PORTFOLIO = 'loader_updating_portfolio'
export const SEARCH_SECURITY_NAME = 'search_security_name'
export const SEARCH_SECURITY_SYMBOL = 'search_security_symbol'
export const SEARCH_HEADER = 'search_header'
export const SEARCH_BODY_NOT_FOUND = 'search_body_not_found'
export const SEARCH_CATEGORY = 'search_category_'
export const ALLOCATION_MODAL_ADD_BUTTON = 'allocation_modal_add_button'
export const ALLOCATION_MODAL_BANNER = 'allocation_modal_banner'
export const ALLOCATION_MODAL_BASE_PERCENTAGE =
  'allocation_modal_base_percentage'
export const ALLOCATION_MODAL_CUSTOM_PERCENTAGE =
  'allocation_modal_custom_percentage'
export const ALLOCATION_MODAL_INPUT = 'allocation_modal_input'
export const ALLOCATION_MODAL_SET_TARGET = 'allocation_modal_set_target'
export const ALLOCATION_MODAL_SUBTRACT_BUTTON =
  'allocation_modal_subtract_button'
export const ALLOCATION_MODAL_ALERT_ICON = 'allocation_modal_alert_icon'
export const SECURITY_DETAILS_ADD_TO_PORTFOLIO =
  'security_details_add_to_portfolio'
export const SECURITY_DETAILS_MARKET_CAP = 'security_details_market_cap'
export const SECURITY_DETAILS_SHARE_PRICE = 'security_details_share_price'
export const SECURITY_DETAILS_SYMBOL = 'security_details_symbol'
export const SECURITY_DETAILS_VOLUME = 'security_details_volume'
export const SECURITY_DETAILS_CUSTOM_LIMIT_REACHED_MODAL =
  'security_details_custom_limit_reached_modal'
export const PORTFOLIO_WIDGET_PASSIONS_LAUNCH =
  'portfolio_widget_passions_launch'
export const PORTFOLIO_RISK_GO_TO_RECOMMENDED =
  'portfolio_risk_go_to_recommended'
export const PORTFOLIO_RISK_DISCLOSURE = 'portfolio_risk_disclosure'
export const PORTFOLIO_INDICATOR = 'portfolio_indicator'
export const PORTFOLIO_DESCRIPTION = 'portfolio_description'
export const PORTFOLIO_VALUE = 'portfolio_value'
export const PORTFOLIO_ETF = 'portfolio_etf'
export const PORTFOLIO_STOCK = 'portfolio_stock'
export const PORTFOLIO_SETTINGS_CARD = 'portfolio_settings_card'
export const PORTFOLIO_RISK = 'portfolio_risk'
export const PORTFOLIO_INVESTOR_PROFILE = 'portfolio_investor_profile'
export const PORTFOLIO_THEME = 'portfolio_theme'
export const PORTFOLIO_SUSTAINABILITY_LINK = 'portfolio_sustainability_link'
export const PORTFOLIO_ARROW = 'portfolio_arrow'
export const PORTFOLIO_ARROW_LEFT = 'portfolio_arrow_left'
export const PORTFOLIO_ARROW_RIGHT = 'portfolio_arrow_right'
export const PORTFOLIO_BONDS_PERCENTAGE = 'bonds_percentage'
export const PORTFOLIO_STOCKS_PERCENTAGE = 'stocks_percentage'
export const PORTFOLIO_CRYPTO_PERCENTAGE = 'crypto_percentage'
export const PORTFOLIO_CHANGE_PORTFOLIO_BUTTON =
  'portfolio_change_portfolio_button'
export const PORTFOLIO_RISK_INDICATOR_CONTAINER =
  'portfolio_risk_indicator_container'
export const PORTFOLIO_RECOMMENDED_RISK = 'portfolio_recommended_risk'
export const PORTFOLIO_CURRENT_RISK_VIEW_INDICATOR =
  'portfolio_current_risk_view_indicator'
export const PORTFOLIO_THEME_SELECT_CORE_BUTTON =
  'portfolio_theme_select_core_button'
export const PORTFOLIO_THEME_SELECT_SUSTAINABLE_BUTTON =
  'portfolio_theme_select_sustainable_button'
export const PORTFOLIO_THEME_SUSTAINABLE_LEARN_BUTTON =
  'portfolio_theme_sustainable_learn_button'
export const PORTFOLIO_THEME_SELECT_NEXT_BUTTON =
  'portfolio_theme_select_next_button'
export const PORTFOLIO_THEME_SELECT_DISCLOSURE_LINK =
  'portfolio_theme_select_disclosure_link'
export const PORTFOLIO_THEME_PREVIEW_CANCEL_BUTTON =
  'portfolio_theme_preview_cancel_button'
export const PORTFOLIO_THEME_PREVIEW_CHANGE_BUTTON =
  'portfolio_theme_preview_change_button'
export const PORTFOLIO_THEME_UPDATED_DONE_BUTTON =
  'portfolio_theme_updated_done_button'
export const SIMPLE_NAV_BAR_X_BUTTON = 'simple_nav_bar_x_button'
export const EMPTY_NAV_BAR_CONTAINER = 'empty_nav_bar_container'
export const PORTFOLIO_ESG_EDUCATION_TOUR_LEFT_ARROW =
  'portfolio_esg_education_tour_left_arrow'
export const PORTFOLIO_ESG_EDUCATION_TOUR_RIGHT_ARROW =
  'portfolio_esg_education_tour_right_arrow'
export const PORTFOLIO_ESG_EDUCATION_TOUR_LETS_GO_BUTTON =
  'portfolio_esg_education_tour_lets_go_button'
export const PORTFOLIO_ESG_EDUCATION_TOUR_DONE_BUTTON =
  'portfolio_esg_education_tour_done_button'
export const PORTFOLIO_ALLOCATION_INFO_NOTE = 'portfolio_allocation_info_note'
export const PORTFOLIO_BASE_ALLOCATION_CARD = 'portfolio_base_allocation_card'

export const PORTFOLIO_ALL_DOUGHNUT_VALUE = 'portfolio_all_doughnut_value'

export const PORTFOLIO_BASE_EDIT_PORTFOLIO = 'portfolio_base_edit_portfolio'
export const PORTFOLIO_CUSTOM_EDIT_PORTFOLIO = 'portfolio_custom_edit_portfolio'
export const PORTFOLIO_ALL_EDIT_PORTFOLIO = 'portfolio_custom_edit_portfolio'

export const PORTFOLIO_EDIT_SUBHEADER = 'portfolio_edit_subheader'
export const PORTFOLIO_EDIT_STOCKS_AND_ETFS_BUTTON =
  'portfolio_edit_stocks_and_etfs_button'
export const PORTFOLIO_EDIT_BITCOIN_BUTTON = 'portfolio_edit_bitcoin_button'
export const PORTFOLIO_EDIT_RISK_BUTTON = 'portfolio_edit_risk_button'
export const PORTFOLIO_EDIT_THEME_BUTTON = 'portfolio_edit_theme_button'
export const PORTFOLIO_EDIT_INVESTOR_PROFILE_BUTTON =
  'portfolio_edit_investor_profile_button'
export const PORTFOLIO_EDIT_STOCK_AND_ETFS_BANNER_BUTTON =
  'portfolio_edit_stocks_and_etfs_banner_button'

export const PORTFOLIO_ALLOCATION_CARD_CURRENT =
  'portfolio_allocation_card_current'
export const PORTFOLIO_ALLOCATION_CARD_TARGETED =
  'portfolio_allocation_card_targeted'

export const PORTFOLIO_CUSTOM_LAYOUT = 'portfolio_custom_layout'
export const PORTFOLIO_CUSTOM_ALLOCATION_CARD =
  'portfolio_custom_allocation_card'
export const PORTFOLIO_BASE_STATS_YTD_RETURN = 'portfolio_base_stats_ytd_return'
export const PORTFOLIO_BASE_STATS_YTD_EARNINGS =
  'portfolio_base_stats_ytd_earnings'
export const PORTFOLIO_BASE_STATS_BONDS = 'portfolio_base_stats_bonds'
export const PORTFOLIO_BASE_STATS_STOCKS = 'portfolio_base_stats_stocks'
export const PORTFOLIO_BASE_STATS_CRYPTO = 'portfolio_base_stats_crypto'

export const PORTFOLIO_CUSTOM_START_CUSTOMIZING_BUTTON =
  'portfolio_custom_start_customizing_button'
export const PORTFOLIO_CUSTOM_STATS_YTD_EARNINGS =
  'portfolio_custom_stats_ytd_earnings'
export const PORTFOLIO_CUSTOM_STATS_YTD_RETURN =
  'portfolio_custom_stats_ytd_return'
export const PORTFOLIO_CUSTOM_SUBHEADER = 'portfolio_custom_subheader'
export const PORTFOLIO_CUSTOM_STATS_ETFS = 'portfolio_custom_stats_etfs'
export const PORTFOLIO_CUSTOM_STATS_STOCKS = 'portfolio_custom_stats_stocks'

export const PORTFOLIO_ALL_ALLOCATION_CARD = 'portfolio_all_allocation_card'
export const PORTFOLIO_ALL_STATS_YTD_RETURN = 'portfolio_all_stats_ytd_return'
export const PORTFOLIO_ALL_STATS_YTD_EARNINGS =
  'portfolio_all_stats_ytd_earnings'
export const PORTFOLIO_ALL_STATS_BONDS = 'portfolio_all_stats_bonds'
export const PORTFOLIO_ALL_STATS_CRYPTO = 'portfolio_all_stats_crypto'
export const PORTFOLIO_ALL_STATS_STOCKS = 'portfolio_all_stats_stocks'

export const STOCKS_VALUE = 'stocks_value'
export const BONDS_VALUE = 'bonds_value'

export const FUND_HEADING = 'fund_heading'
export const FUND_DETAILS_ACTION_BUTTON = 'action_button_fund_details'
export const FUND_DETAILS = 'fund_details'
export const FUND_OPENING_PRICE = 'fund_opening_price'
export const FUND_PREVIOUS_CLOSE_PRICE = 'fund_previous_close_price'
export const FUND_WEEKLY_RANGE = 'fund_weekly_range'
export const FUND_VOLUME = 'fund_volume'
export const FUND_YEAR_TO_DATE_RETURN = 'fund_year_to_date_return'
export const FUND_GRAPH_DATE = 'fund_graph_date_'
export const FUND_GRAPH = 'fund_graph'
export const GRAPH_DETAILS = 'graph_details'
export const FEATURED_HOLDINGS = 'featured_holdings'
export const DEPOSIT_PERCENTAGE = 'deposit_percentage'
export const DEPOSIT_TO = 'deposit_to'
export const HERO_BANNER = 'hero_banner'
export const HERO_BODY = 'hero_body'
export const HERO_CARD = 'hero_card'
export const HERO_BANNER_CTA_BUTTON = 'hero_banner_cta_button'
export const NO_PENDING_ACTIVITY = 'no_pending_activity'
export const PAST_EVENT_CARDS = 'past_event_cards'
export const PAST_ITEM_CONTAINER = 'past_item_container'
export const RECURRING_SETTINGS = 'recurring_settings'
export const PENDING_SECTION = 'pending_section'
export const COMPLETED_SECTION = 'completed_section'
export const TRANSACTION = 'transaction'
export const PROJECTED_VALUE_BANNER = 'projected_value_banner'
export const PROJECTED_DISCLAIMER = 'projected_disclaimer'

export const ROUNDUP_TOGGLE_STATUS = 'roundup_toggle_status'
export const ROUNDUP_MULTIPLIER_STATUS = 'roundup_multiplier_status'
export const SAVED_POPUP = 'saved_popup'
export const ROUNDUPS_SETTINGS = 'roundups_settings'
export const MODAL_BODY = 'modal_body'
export const MODAL_CONTAINER = 'modal_container'
export const SIGNATURE_PAD = 'signature_pad'
export const SIGNATURE_NEXT_BUTTON = 'signature_next_button'
export const ROUNDUPS_PROGRESS_BAR_VALUES = 'roundups_progress_bar_values'
export const ROUNDUPS_TOTAL_INVESTED = 'roundups_total_invested'
export const ROUNDUPS_INVESTED_COUNT = 'roundups_invested_count'
export const ROUNDUP_TOTAL = 'roundup_total'
export const ROUNDUP_MULTIPLIER_DETAILS = 'roundup_multiplier_details'
export const ROUNDUP_TRANSACTION_NAME = 'roundup_transaction_name'
export const ROUNDUP_TRANSACTION_AMOUNT = 'roundup_transaction_amount'
export const ROUNDUP_MODAL_ACTION_CANCEL = 'roundup_modal_action_cancel'
export const ROUNDUP_MODAL_ACTION_CONFIRM = 'roundup_modal_action_confirm'

export const INDIVIDUAL_ROUNDUP_PENDING_ICON = 'individual_roundup_pending_icon'
export const INDIVIDUAL_ROUNDUP_WAITING_ICON = 'individual_roundup_waiting_icon'
export const INDIVIDUAL_ROUNDUP_INVESTED_ICON =
  'individual_roundup_invested_icon'
export const INDIVIDUAL_ROUNDUP_INSTANT_ICON = 'individual_roundup_instant_icon'

export const STATEMENT_DROPDOWN_OPTION = 'statement_dropdown_option'

const LINKED_ACCOUNTS = 'linked_accounts'
export const LINKED_ACCOUNTS_FUNDING_SOURCE_OPTION = `${LINKED_ACCOUNTS}_funding_source_option`
export const LINKED_ACCOUNTS_CHANGE_FUNDING_SOURCE_BUTTON = `${LINKED_ACCOUNTS}_change_funding_source_button`
export const LINKED_ACCOUNTS_LINK_ACCOUNT_BUTTON = `${LINKED_ACCOUNTS}_link_account_button_button`
export const LINKED_ACCOUNTS_FIX_ACCOUNT_BUTTON = `${LINKED_ACCOUNTS}_fix_account_button`
export const LINKED_ACCOUNTS_ADD_ACCOUNT_BUTTON = `${LINKED_ACCOUNTS}_add_account_button`
export const LINKED_ACCOUNTS_PRIMARY_CHECKING_NAME = `${LINKED_ACCOUNTS}_primary_checking_name`

export const INSTITUTION_PAGE = 'institutions_page'
export const INSTITUTION_PAGE_ACTION_STRIP_ACTION = `${INSTITUTION_PAGE}_action_strip_action`
export const INSTITUTION_PAGE_UNLINK_BUTTON = `${INSTITUTION_PAGE}_unlink_button`
export const INSTITUTION_PAGE_LOGO = `${INSTITUTION_PAGE}_logo`
export const INSTITUTION_PAGE_INSTITUTION_NAME = `${INSTITUTION_PAGE}_institution_name`
export const INSTITUTION_PAGE_LAST_UPDATED_ON = `${INSTITUTION_PAGE}_last_update_on`
export const INSTITUTION_PAGE_LINKED_SUBACCOUNT_TITLE = `${INSTITUTION_PAGE}_linked_subaccount_title`
export const INSTITUTION_PAGE_PRIMARY_CHECKING_BADGE = `${INSTITUTION_PAGE}_primary_checking_badge`
export const INSTITUTION_PAGE_LINKED_SUBACCOUNT_LIST = `${INSTITUTION_PAGE}_linked_subaccount_list`
export const INSTITUTION_PAGE_LINKED_SUBACCOUNT_BALANCE = `${INSTITUTION_PAGE}_linked_subaccount_balance`
export const INSTITUTION_PAGE_LINKED_SUBACCOUNT_ROUNDUPS_TOGGLE = `${INSTITUTION_PAGE}_linked_subaccount_roundups_toggle`
export const INSTITUTION_PAGE_LINKED_SUBACCOUNT_LOADING = `${INSTITUTION_PAGE}_linked_subaccount_loading`
export const INSTITUTION_PAGE_ROUNDUPS_UNAVAILABLE_FOOTNOTE = `${INSTITUTION_PAGE}_roundups_unavailable_footnote`
export const INSTITUTION_PAGE_RDV_FORM = `${INSTITUTION_PAGE}_rdv_form`
export const INSTITUTION_PAGE_RDVS_SETTLED_AT_CONTAINER = `${INSTITUTION_PAGE}_rdvs_settled_at_container`
export const INSTITUTION_PAGE_RDVS_SETTLED_AT = `${INSTITUTION_PAGE}_rdvs_settled_at`
export const INSTITUTION_PAGE_LINKING_ERROR_MESSAGE = `${INSTITUTION_PAGE}_linking_error_message`
export const INSTITUTION_PAGE_LINKING_ERROR_HEADLINE = `${INSTITUTION_PAGE}_linking_error_headline`
export const INSTITUTION_PAGE_LINKING_RELINK_CTA = `${INSTITUTION_PAGE}_relink_cta`
export const INSTITUTION_PAGE_CREDENTIALS_CHANGED_PROMPT = `${INSTITUTION_PAGE}_credentials_changed_prompt`
export const INSTITUTION_PAGE_CREDENTIALS_CHANGED_PROMPT_YES_CTA = `${INSTITUTION_PAGE}_credentials_changed_prompt_yes_cta`
export const INSTITUTION_PAGE_CREDENTIALS_CHANGED_PROMPT_NO_CTA = `${INSTITUTION_PAGE}_credentials_changed_prompt_no_cta`
export const INSTITUTION_PAGE_VERIFICATION_FAILED_MODAL = `${INSTITUTION_PAGE}_verification_failed_modal`
export const INSTITUTION_PAGE_VERIFICATION_SUCCESS_MODAL = `${INSTITUTION_PAGE}_verification_success_modal`

export const NO_STATEMENTS_CARD = 'no_statements_card'
export const STATEMENT_ROW = 'statement'
export const PRODUCT_SELECTION = 'product_selection'
export const DOCUMENT_SELECTION = 'document_selection'
export const RETURNED_CHECK_MONTH = 'returned_check_month'

const grow_page = 'grow_page'
export const GROW_CATEGORY_CARD = `${grow_page}_category_card`
export const GROW_ARTICLE_CARD = `${grow_page}_article_card`
export const GROW_TOPIC_LINK = `${grow_page}_topic_link`
export const GROW_UP_NEXT = `${grow_page}_up_next`
export const GROW_ARTICLE_CONTENT = 'grow_article_content'
export const GROW_ARTICLE_FOOTNOTE = 'grow_article_footnote'
export const GROW_AUTHOR_BIO = 'grow_author_bio'
export const AUTHOR_BLURB = 'author_blurb'
export const ARTICLE_CONTENT = 'article_content'
export const GROW_ARTICLE_HERO_IMAGE = 'grow_article_hero_image'
export const NEXT_ARTICLE = 'next_article'

export const POTENTIAL_CHART_HERO_CARD = 'potential_chart_hero_card'
export const POTENTIAL_DROPDOWN_PRODUCT_SELECTION =
  'potential_dropdown_product_selection'
export const POTENTIAL_DROPDOWN_PRODUCT_OPTION = 'potential_dropdown_product_'
export const POTENTIAL_RECURRING_BUTTON = 'potential_recurring_button'
export const POTENTIAL_ROUNDUPS_BUTTON = 'potential_roundups_button'
export const POTENTIAL_SMART_DEPOSIT_BUTTON = 'potential_smart_deposit_button'
export const POTENITAL_INVESTMENT_MODIFICATION_MENU =
  'potential_investment_modification_menu'
export const POTENTIAL_GRAPH_CONTAINER_WRAPPER =
  'potential_graph_container_wrapper'
export const POTENTIAL_GRAPH_INNER_CONTAINER = 'potential_graph_inner_container'

export const PAST_PENDING_PIZZA_TRACKER = 'past_pending_pizza_tracker'
export const PAST_CASH_VALUE = 'past_cash_value'
export const PAST_ICON = 'past_icon'
export const PAST_ICON_PLACEHOLDER = 'past_icon_placeholder'
export const MULTIPART_INVESTMENT_MERCHANT =
  'past_multipart_investment_merchant'
export const MULTIPART_INVESTMENT_BREAKDOWN =
  'past_multipart_investment_breakdown'
export const MULTIPART_INVESTMENT_INVESTMENT_LIST =
  'past_multipart_investment_list'
export const PAST_NO_ACTIVITY = 'past_no_activity'
export const PAST_CONTENT = 'past_content'
export const PAST_SECTION = 'past_section'
export const PAST_SECTION_HEADING = 'past_section_heading'
export const PAST_CORE_COMPONENT = 'past_core_component'
export const PAST_SPEND_COMPONENT = 'past_spend_component'
export const PAST_LATER_COMPONENT = 'past_later_component'
export const PAST_EMERGENCY_FUND_COMPONENT = 'past_emergency_fund_component'

export const LINK_FUNDING_SOURCE_PROMPT = 'link_funding_source_prompt'
export const LINK_CARD_PROMPT = 'link_card_prompt'
export const REDIRECT_TO_MOBILE_BODY = 'redirect_to_mobile_body'
export const REDIRECT_TO_MOBILE_HEADER = 'redirect_to_mobile_header'
export const RELINK_CARD_PROMPT = 'relink_card_prompt'
export const RESTART_INVESTMENTS_PROMPT = 'restart_investments_prompt'
export const RESTART_INVESTMENTS_SUCCESS_MODAL =
  'restart_investments_success_modal'
export const CONFIRM_INVESTMENT_PROMPT = 'confirm_investment_prompt'
export const INVESTMENT_SUCCESS_MODAL = 'investment_success_modal'
export const ROUNDUP_LEARN_MORE_PROMPT = 'roundup_learn_more_prompt'
export const ROUNDUP_LEARN_MORE_BUTTON = 'roundup_learn_more_button'

export const ROUNDUP_ITEM = 'roundup_item'
export const ROUNDUP_ITEM_ICON = 'roundup_item_icon'
export const ROUNDUP_GROUP = 'roundup_group'
export const ROUNDUP_LEDGER = 'roundup_ledger'
export const ROUNDUP_SECTION = 'roundup_section'
export const ROUNDUP_SECTION_HEADING = 'roundup_section_heading'
export const ROUNDUP_PROGRESS_POPOVER = 'roundup_progress_popover'
export const ROUNDUP_INFO_ICON = 'round-ups-info'
export const ROUNDUP_SETTINGS_ICON = 'round-ups-settings'
export const ROUND_UPS_PAGE = 'round_ups_page'

export const TEXT_INPUT_ERROR = 'text_input_error'
export const SPEND_ACTIVATION_TRANSFER = 'spend_activation_transfer_screen'
export const SPEND_ACTIVATION_TRANSFER_BUTTON =
  'spend_activation_transfer_button'

export const ACTION_STRIP = 'action_strip'
export const ACTION_STRIP_BACK = 'action_strip_back'
export const ACTION_STRIP_CANCEL = 'action_strip_cancel'

export const SLIDER_HANDLE = 'slider_handle'

export const USER_AVATAR = 'user_avatar'

export const PAST_NAV_PILL = 'past_button'
export const PRESENT_NAV_PILL = 'present_button'
export const POTENTIAL_NAV_PILL = 'potential_button'

export const FEEDBACK_THUMBS_UP_BUTTON = 'feedback_thumbs_up_button'
export const FEEDBACK_THUMBS_DOWN_BUTTON = 'feedback_thumbs_down_button'

export const SEND_CHECK_FORM = 'send_check_form'
export const SEND_CHECK = 'send_check'
export const SEND_CHECK_MODAL = 'send_check_modal'
export const SEND_CHECK_CHECK_HISTORY = 'send_check_check_history'
export const SEND_CHECK_RECIPIENT_INPUT = 'send_check_recipient_input'
export const SEND_CHECK_CTA = 'send_check_cta'

export const CANCEL_CHECK_BUTTON = 'check_detail_cancel_check_button'

const check_history = 'check_history'
const check_detail = 'check_detail'
export const CHECK_DETAIL = `${check_history}_${check_detail}`
export const CHECK_HISTORY_LETTER_CONTAINER = `${check_history}_letter_container`
export const CHECK_HISTORY_CHECK_CONTAINER = `${check_history}_check_container`
export const CHECK_HISTORY_SCREEN = `${check_history}_screen`
export const CHECK_HISTORY_CANCELLED_ICON = `${check_history}_cancelled_icon`
export const CHECK_HISTORY_PENDING_ICON = `${check_history}_pending_icon`
export const CHECK_HISTORY_RECIPIENT_NAME = `${check_history}_recipient_name`
export const CHECK_HISTORY_MEMO_DETAILS = `${check_history}_memo_details`
export const CHECK_HISTORY_CHECK_AMOUNT = `${check_history}_check_amount`
export const CHECK_HISTORY_CANCELLED_STATE = `${check_history}_cancelled_state`

export const CHECK_DETAIL_CHECK_AMOUNT = `${check_detail}_check_amount`
export const CHECK_DETAIL_RECIPIENT_NAME = `${check_detail}_recipient_name`
export const CHECK_DETAIL_FAILURE_REASON = `${check_detail}_failure_reason`
export const CHECK_DETAIL_MEMO = `${check_detail}_memo`
export const CHECK_DETAIL_ADDRESS_STREET_1 = `${check_detail}_address_street_1`
export const CHECK_DETAIL_ADDRESS_STREET_2 = `${check_detail}_address_street_2`
export const CHECK_DETAIL_ADDRESS_CITY_STATE_ZIP = `${check_detail}_city_state_zip`
export const CHECK_DETAIL_SENT_DATE = `${check_detail}_sent_date`
export const CHECK_DETAIL_ESTIMATED_ARRIVAL_DATE = `${check_detail}_estimated_arrival_date`
export const CHECK_DETAIL_CHECK_NUMBER = `${check_detail}_check_number`
export const CHECK_DETAIL_VOID_INFO = `${check_detail}_void_info`
export const CHECK_DETAIL_CANCELLED_DATE = `${check_detail}_cancelled_date`

export const TOPIC_LIST_ITEM = 'topic_list_item'

export const FAQ_LIST_ITEM = 'faq_list_item'
export const FAQ_LIST_ITEM_BODY = 'faq_list_item_body'

export const GROW_TOPIC_ARTICLE_CONTENT = 'grow_topic_article_content'
export const GROW_TOPIC_LIST_ITEM = 'grow_topic_page_list_item'
export const GROW_TOPIC_TITLE_CARD = 'grow_topic_page_title_card'

export const SPEND_PREORDER_START_BUTTON = 'spend_preorder_start_button'

export const SPEND_AVAILABLE_BALANCE_LABEL = 'spend_available_balance_label'

export const SPEND_ATM_FINDER_VENUE_TOTAL = 'spend_atm_finder_venue_total'
export const SPEND_ATM_FINDER_SEARCH_BAR = 'spend_atm_finder_search_bar'
export const SPEND_ATM_FINDER_SEARCH_RESULT_CONTAINER =
  'spend_atm_finder_search_result_container'
export const SPEND_ATM_FINDER_SEARCH_RESULT = 'spend_atm_finder_search_result'
export const SPEND_ATM_FINDER_SEARCH_RESULT_NAME =
  'spend_atm_finder_search_result_name'
export const SPEND_ATM_FINDER_GET_DIRECTIONS_CTA =
  'spend_atm_finder_get_directions_cta'
export const SPEND_ATM_FINDER_FAQ_BUTTON = 'spend_atm_finder_faq_button'
export const SPEND_ATM_FINDER_DETAILS_HEADER = 'spend_atm_finder_details_header'
export const SPEND_ATM_FINDER_DETAILS_BACK_BUTTON =
  'spend_atm_finder_details_back_button'
export const SPEND_ATM_FINDER_DETAILS_TITLE = 'spend_atm_finder_details_title'
export const SPEND_ATM_FINDER_DETAILS_ADDRESS_INFO =
  'spend_atm_finder_details_address_info'
export const SPEND_ATM_FINDER_DETAILS_DISTANCE =
  'spend_atm_finder_details_distance'
export const SPEND_ATM_FINDER_MAP_MARKER = 'spend_atm_finder_map_marker'

export const SPEND_SIGNUP_LANDER_CONTAINER = 'spend_signup_lander_container'
export const SPEND_SIGNUP_LANDER_CTA = 'spend_signup_lander_cta'
export const SPEND_SIGNUP_UNVERIFIED_CUSTOMER =
  'spend_signup_unverified_customer'
export const CHECKING_SIGNUP_DOCV_RESULTS_CTA =
  'checking_signup_docv_results_cta'
export const CHECKING_SIGNUP_DOCV_RESULTS_ERROR_MODAL =
  'checking_signup_docv_results_error_modal'

export const MOC_LANDER_GET_STARTED_CTA = 'moc_lander_explore_cta'
export const MOC_ADDRESS_CONTAINER = 'moc_address_screen_container'
export const MOC_ADDRESS_CTA = 'moc_address_cta'
export const MOC_ADDRESS_EDIT_CTA = 'moc_address_edit_cta'
export const MOC_ADDRESS_EDIT_CONTAINER = 'moc_address_edit_screen_container'
export const MOC_ADDRESS_EDIT_CONFIRM_CTA = 'moc_address_edit_confirm_cta'
export const MOC_ADDRESS_CORRECTED_ADDRESS_CONTAINER =
  'moc_address_corrected_address_container'
export const MOC_ADDRESS_CORRECTED_CONFIRM_CTA =
  'moc_address_corrected_confirm_cta'
export const MOC_OCCUPATION_CONTAINER = 'moc_address_screen_container'
export const MOC_OCCUPATION_CTA = 'moc_occupation_cta'
export const MOC_CONFIRM_CONTAINER = 'moc_confirm_screen_container'
export const MOC_CONFIRM_CTA = 'moc_confirm_cta'
export const MOC_FUNDING_CONTAINER = 'moc_funding_screen_container'
export const MOC_FUNDING_HEADING = 'moc_funding_screen_heading'
export const MOC_FUNDING_DD_SECTION = 'moc_funding_screen_dd_section'
export const MOC_FUNDING_OUTSIDE_FS_SECTION =
  'moc_funding_screen_outside_fs_section'
export const MOC_FUNDING_DISCLAIMER_SECTION =
  'moc_funding_screen_disclaimer_section'
export const MOC_FUNDING_PAUSED_CONTAINER =
  'moc_funding_paused_screen_container'

export const EMERGENCY_FUND_AVAILABLE_BALANCE_LABEL =
  'emergency_fund_available_balance_label'
export const EMERGENCY_FUND_HOME_SCREEN_BANNER_ACCOUNT_VALUE =
  'emergency_fund_home_screen_banner_account_value'
export const EMERGENCY_FUND_HOME_SCREEN_BANNER_SUBTITLE =
  'emergency_fund_home_screen_banner_subtitle'
export const EMERGENCY_FUND_HOME_SCREEN_BANNER_ACTION_MESSAGE =
  'emergency_fund_home_screen_banner_action_message'
export const EMERGENCY_FUND_HOME_SCREEN_BANNER_GOAL_VALUE =
  'emergency_fund_home_screen_banner_goal_value'
export const EMERGENCY_FUND_HOME_HERO_CONTAINER =
  'emergency_fund_home_hero_container'
export const EMERGENCY_FUND_DOWNLOAD_ACORNS_CTA =
  'emergency_fund_download_acorns_cta'

export const RECURRING_CALCULATOR_SALARY_PROMPT_CARD =
  'recurring_calculator_salary_prompt_card'
export const RECURRING_CALCULATOR_SALARY_PROMPT_MINIMUM_VALUE =
  'recurring_calculator_salary_prompt_minimum_value'
export const RECURRING_CALCULATOR_SALARY_PROMPT_MAXIMUM_VALUE =
  'recurring_calculator_salary_prompt_maximum_value'
export const RECURRING_CALCULATOR_SALARY_PROMPT_MONTHLY_INCOME =
  'recurring_calculator_salary_prompt_monthly_income'
export const RECURRING_CALCULATOR_SALARY_PROMPT_NEXT_STEP_BUTTON =
  'recurring_calculator_salary_prompt_next_step_button'
export const RECURRING_CALCULATOR_SALARY_PROMPT_SLIDER_HANDLE =
  'recurring_calculator_salary_prompt_next_slider_handle'

export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_CARD =
  'recurring_calculator_recommended_amount_card'
export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_VALUE =
  'recurring_calculator_recommended_amount_value'
export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_SELECTED_PERCENTAGE =
  'recurring_calculator_recommended_amount_selected_percentage'
export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_CONFIRMATION_MODAL =
  'recurring_calculator_recommended_amount_confirmation_modal'
export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_MINIMUM_AMOUNT_MODAL =
  'recurring_calculator_recommended_amount_minimum_amount_modal'
export const RECURRING_CALCULATOR_RECOMMENDED_AMOUNT_RESET_BUTTON =
  'recurring_calculator_recommended_amount_reset_button'

export const RECURRING_INVESTMENT_FREQUENCY_PICKER =
  'recurring_investment_frequency_picker'
export const RECURRING_INVESTMENT_DATE_SELECTOR =
  'recurring_investment_date_selector'
export const REQUEST_SPEND_CARD_REASON_DROPDOWN =
  'request_spend_card_reason_dropdown'

export const RECURRING_TRANSFER_STOP_BUTTON = 'recurring_transfer_stop_button'
export const RECURRING_TRANSFER_SAVE_BUTTON = 'recurring_transfer_save_button'
export const RECURRING_TRANSFER_NEXT_OCCURRENCE_MESSAGE =
  'recurring_transfer_next_occurrence_message'

export const DROPDOWN_BUTTON = 'dropdown_button'
export const DROPDOWN_ITEM = 'dropdown_item'
export const DROPDOWN_LIST = 'dropdown_list'
export const OPTION_DROPDOWN = 'option_dropDown'

export const DOCUMENTS_DOCUMENT_DROPDOWN_CONTAINER = 'document_type'
export const DOCUMENTS_ACCOUNT_DROPDOWN_CONTAINER = 'account_type'

export const DOCUMENT_BLOCK = 'document_block'

export const TAX_CENTER = 'tax_center'
export const TAX_CENTER_FORM_ESTIMATED_DATE_TOOLTIP =
  'tax_center_form_estimated_date_tooltip'
export const DOCUMENT_ITEM = 'document_record'

export const INVESTMENT_DETAILS_PENDING = 'investment_details_pending'

export const VERIFY_ADDRESS_FILE_PREVIEW = 'verify_address_file_preview'
export const VERIFY_ADDRESS_DROPZONE = 'verify_address_drop_zone'
export const VERIFY_ADDRESS_HOVER_ICON = 'verify_address_hover_icon'
export const VERIFY_PROGRESS_BAR = 'verify_progress_bar'

export const VERIFY_IDENTITY_FILE_PREVIEW = 'verify_identity_file_preview'
export const VERIFY_IDENTITY_DROPZONE = 'verify_identity_drop_zone'

export const ACCOUNT_ONBOARDING_SHEET_MODAL = 'account_onboarding_sheet_modal'
export const ACCOUNT_ONBOARDING_CLOSE_BUTTON = 'account_onboarding_close_button'

export const ACTIVITY_SUMMARY_TITLE = 'activity_summary_title'
export const ACTIVITY_SUMMARY_ITEM = 'activity_summary_item'
export const ACTIVITY_SUMMARY_ITEM_TITLE = 'activity_summary_item_title'
export const ACTIVITY_SUMMARY_ITEM_AMOUNT = 'activity_summary_item_amount'

export const HELP_TEXT_CLOSE_ACCOUNT_DETERRENTS =
  'help_text_close_account_deterrents'

export const PERFORMANCE_INVESTMENTS_HEADING = 'your_investments_heading'
export const PERFORMANCE_STOCK_COUNT = 'performance_stock_count'
export const PERFORMANCE_ETF_COUNT = 'peformance_etf_count'
export const PERFORMANCE_INVESTMENTS_SORT_BUTTON =
  'performance_investments_sort_button'
export const PERFORMANCE_GRAPH = 'performance_graph'
export const PERFORMANCE_GAIN_LOSS_CONTAINER = 'performance_gain_loss_container'
export const PERFORMANCE_PRODUCT_BALANCE = 'performance_product_balance'
export const PERFORMANCE_UP_ARROW = 'up_arrow'
export const PERFORMANCE_DOWN_ARROW = 'down_arrow'
export const PERFORMANCE_FIRST_INVESTMENT_CTA = 'first_investment_cta'
export const PERFORMANCE_CONTAINER = 'performance-container'
export const PERFORMANCE_EXPAND = 'performance-expand'
export const TOTAL_GAIN_LOSS_VALUE = 'total_gain_loss_value'
export const TOTAL_GAIN_LOSS = 'total_gain_loss'
export const GAIN_LOSS_TOOLTIP = 'gain_loss_tooltip'
export const MARKET_STATUS = 'market_status'
export const PERFORMANCE_DISCLOSURES = 'disclosures'
export const STICK_WITH_IT_LEARN_MORE = 'stick_with_it_learn_more'
export const STICK_WITH_IT_MODAL = 'stick_with_it_modal'
export const PERFORMANCE_GRAPH_TOOLTIP_DATE = 'performance_graph_tooltip_date'

export const SET_UP_TIPS_DISMISS_BUTTON = 'set_up_tips_dismiss_button'
export const SET_UP_TIPS_DISMISS_MENU = 'set_up_tips_dismiss_menu'
export const SET_UP_TIPS_DISMISS_MENU_OPTION = 'set_up_tips_dismiss_menu_option'
export const SET_UP_TIPS_CAROUSEL_BUTTONS = 'set_up_tips_carousel_buttons'
export const SET_UP_TIPS_CAROUSEL_LEFT_ARROW = 'set_up_tips_carousel_left_arrow'
export const SET_UP_TIPS_CAROUSEL_RIGHT_ARROW =
  'set_up_tips_carousel_right_arrow'
export const SET_UP_TIPS_TIP = 'set_up_tips_tip'

export const ONBOARDING_TIPS_CLOSE_BUTTON = 'onboarding_tips_close_button'
export const ONBOARDING_TIPS_MODAL = 'onboarding_tips_modal'

export const CLOSED_ACCOUNT_AGREEMENTS_CHECKBOX =
  'closed_account_agreements_checkbox'
export const CLOSED_ACCOUNT_REOPEN_ACCOUNT_BUTTON =
  'closed_account_reopen_account_button'
export const CLOSED_ACCOUNT_STATEMENTS_AND_TAXES_BUTTON =
  'closed_account_statements_and_taxes_button'

export const GROW_YOUR_OAK_BOOK_CONTENT = 'grow_your_oak_book_content'
export const GROW_YOUR_OAK_BOOK_DISMISS_BUTTON = 'grow_your_oak_dismiss_button'
export const GROW_YOUR_OAK_BOOK_DOWNLOAD_BUTTON =
  'grow_your_oak_book_download_button'
export const GROW_YOUR_OAK_BOOK_WIDGET = 'grow_your_oak_book_widget'

export const ALERT_MULTIPLE = 'multiple_messages_alert'
export const ADDRESS_DOCUMENT_REQUESTED_USER_ALERT_ITEM =
  'address_document_requested_user_alert'
export const IDENTITY_DOCUMENT_REQUESTED_USER_ALERT_ITEM =
  'identity_document_requested_user_alert'
export const RDV_REQUIRED_USER_ALERT = 'rdv_required_user_alert'
export const INVESTMENTS_PAUSED_USER_ALERT = 'investments_paused_user_alert'
export const SPEND_SMART_DEPOSIT_COMPLETED_ALERT =
  'spend_smart_deposit_completed'
export const MESSAGE_CENTER_MESSAGE_ICON = 'message_center_message_icon'
export const MESSAGE_CENTER_MESSAGE_TITLE = 'message_center_message_title'
export const MESSAGE_CENTER_MESSAGE_BODY = 'message_center_message_body'
export const MESSAGE_CENTER_MESSAGE_DATE = 'message_center_message_date'
export const MESSAGE_CENTER_MESSAGE_UNREAD_DOT =
  'message_center_message_unread_dot'
export const MESSAGE_CENTER_ACTION_NEEDED_HEADER =
  'message_center_action_needed_header'
export const MESSAGE_CENTER_MESSAGE_ALERT_DOT =
  'message_center_message_alert_dot'
export const MESSAGE_CENTER_MARK_ALL_AS_READ_CTA =
  'message_center_mark_all_as_read_cta'
export const MESSAGE_CENTER_MARK_ALL_AS_READ_MOBILE_TOGGLE =
  'message_center_mark_all_as_read_mobile_toggle'

export const MFA_HELP_BUTTON = 'mfa_help_button'
export const MFA_MANAGE_EMAIL_TILE = 'mfa_manage_email_tile'
export const MFA_MANAGE_PHONE_TILE = 'mfa_manage_phone_tile'
export const MFA_NEXT_BUTTON = 'mfa_next_button'
export const MFA_SKIP_BUTTON = 'mfa_skip_button'
export const MFA_SET_PHONE_DEFAULT_BUTTON = 'mfa_set_phone_default_button'
export const MFA_SET_EMAIL_DEFAULT_BUTTON = 'mfa_set_email_default_button'

export const MFA_PAGE_LANDING = 'mfa_page_landing'
export const MFA_PAGE_MANAGE = 'mfa_page_manage'
export const MFA_PAGE_UPDATE_INFO = 'mfa_page_update_info'
export const MFA_TEXT_INPUT = 'text_input'

export const PASSWORD_CONTINUE_BUTTON = 'password_continue_button'
export const PASSWORD_UPDATE_BUTTON = 'password_update_button'
export const PASSWORD_UPDATE_SUCCESS = 'password_update_success'
export const PRICING_INTERSTITIAL = {
  PAGE_TITLE: 'pricing_interstitial_page_title',
  TIER_NAME: 'pricing_interstitial_tier_name',
  TIER_PRICE: 'pricing_interstitial_tier_price',
  BENEFITS_CONTAINER: 'pricing_interstitial_tier_benefits',
  BUNDLE_CONTAINER: 'pricing_interstitial_tier_bundle_container',
  CTA: 'pricing_interstitial_cta',
}

export const PROFILE_PHONE_NUMBER_BUTTON = 'profile_phone_number_button'
export const PROFILE_EMAIL_BUTTON = 'profile_email_button'
export const PROFILE_ADD_TRUSTED_CONTACT = 'profile_add_trusted_contact_button'
export const PROFILE_CONTACT_INFO_SECTION = 'profile_contact_info_section'
export const PROFILE_TRUSTED_CONTACT_SECTION = 'profile_trusted_contact_section'

export const TRUSTED_CONTACT_FORM_SELECTION_BUTTON =
  'trusted_contact_form_selection_button'
export const TRUSTED_CONTACT_FORM_SELECTION_LABEL =
  'trusted_contact_form_selection_label'
export const TRUSTED_CONTACT_FORM_SELECTION_CHECKBOX =
  'trusted_contact_form_selection_checkbox'

export const AOT_NEXT_STEPS_FAQ_BUTTON = 'aot_next_steps_faq_button'
export const AOT_REACHED_NEXT_STEPS_BUTTON = 'aot_reached_next_steps_button'
export const AOT_REACHED_PAST_BUTTON = 'aot_reached_past_button'
export const AOT_REACHED_PERFORMANCE_BUTTON = 'aot_reached_performance_button'
export const AOT_REACHED_FAQ_BUTTON = 'aot_reached_faq_button'

export const TRANSACTION_DETAILS_TITLE = 'transaction_details_title'
export const TRANSACTION_DETAILS_AMOUNT = 'transaction_details_amount'
export const TRANSACTION_DETAILS_STATUS = 'transaction_details_status'
export const TRANSACTION_DETAILS_TYPE = 'transaction_details_type'
export const TRANSACTION_DETAILS_DESCRIPTION = 'transaction_details_description'
export const USER_HELP_BUTTON = 'user_help_agatha_button'

export const PAUSE_INVESTMENTS_BUTTON = 'pause_investments_button'
export const INVEST_MINI_BUTTON = 'invest_mini_button'
export const INVEST_DONE_BUTTON = 'invest_done_button'
export const INVEST_UNPAUSE_MODAL_ACCOUNT_BALANCE =
  'invest_unpause_modal_account_balance'
export const INVEST_MODAL_ACCOUNT_BALANCE = 'invest_modal_account_balance'
export const SELECTION_LIST_ROW = 'selection_list_row'
export const UNVERIFIED_DEPOSIT_LIMIT_MODAL = 'unverified_deposit_limit_modal'
export const INVEST_TRANSFER_DRAWER = 'invest_transfer_drawer'
export const INVEST_CONFIRM_DRAWER = 'invest_confirm_drawer'
export const INVEST_CONFIRM_DRAWER_CTA = 'invest_confirm_drawer_cta'
export const REFERRAL_HISTORY_PAST_OFFERS = 'referral_history_past_offers'
export const REFERRAL_INVITE_DETAILS_CARD_HEADER =
  'referral_invite_details_card_header'
export const REFERRAL_INVITE_DETAILS_CARD_HEADER_HOW_IT_WORKS = `${REFERRAL_INVITE_DETAILS_CARD_HEADER}_how_it_works`
export const REFERRAL_INVITE_DETAILS_CARD_HEADER_FAQ = `${REFERRAL_INVITE_DETAILS_CARD_HEADER}_faq`
export const REFERRAL_INVITE_DETAILS_CARD_HEADER_HISTORY = `${REFERRAL_INVITE_DETAILS_CARD_HEADER}_history`
export const REFERRAL_INVITE_DETAILS_CARD_HEADER_PENDING_OFFERS = `${REFERRAL_INVITE_DETAILS_CARD_HEADER}_pending_offers`
export const REFERRAL_INVITE_DETAILS_STEP = 'referral_invite_details_step'
export const REFERRAL_INVITE_HISTORY_CTA = 'referral_invite_history_cta'
export const REFERRAL_INVITE_OFFER_CTA = 'referral_invite_offer_cta'
export const REFERRAL_INVITE_OFFER_CARD_HEADER =
  'referral_invite_offer_card_header'
export const REFERRAL_INVITE_OFFER_IMAGE = 'referral_invite_offer_image'
export const REFERRAL_INVITE_OFFER_LINKS = 'referral_invite_offer_links'
export const REFERRAL_INVITE_OFFER_ROW = 'referral_invite_offer_row_'
export const REFERRAL_INVITE_OFFER_ROW_SUBTITLE_SIGNUP =
  'referral_invite_offer_row_subtitle_signup_'
export const REFERRAL_INVITE_OFFER_ROW_SUBTITLE_INVESTMENT =
  'referral_invite_offer_row_subtitle_investment_'
export const REFERRAL_INVITE_OFFER_ROW_BADGE =
  'referral_invite_offer_row_badge_'
export const REFERRAL_INVITE_OFFER_ROW_CTA = 'referral_invite_offer_row_cta_'
export const REFERRAL_INVITE_INVEST_LOCK_TITLE =
  'referral_invite_invest_lock_title'

export const REFERRAL_OFFER_DETAILS_PILL_SUBTITLE =
  'referral_offer_details_pill_subtitle'
export const REFERRAL_OFFER_DETAILS_CONDENSED_TITLE =
  'referral_offer_details_condensed_title'
export const REFERRAL_OFFER_DETAILS_SUB_HEADER =
  'referral_offer_details_sub_header'
export const REFERRAL_OFFER_DETAILS_FRIENDS_COMPLETED =
  'referral_offer_details_friends_completed'
export const REFERRAL_OFFER_DETAILS_FRIENDS_SIGNEDUP =
  'referral_offer_details_friends_signedup'

export const REFERRAL_DISCLOSURE_AGREE_BUTTON =
  'referral_disclosure_agree_button'
export const REFERRAL_DISCLOSURE_BACK_BUTTON = 'referral_disclosure_back_button'
export const REFERRAL_DISCLOSURE_DISCLAIMER = 'referral_disclosure_disclaimer'
export const REFERRAL_DISCLOSURE_DOCUMENT_TEXT =
  'referral_disclosure_document_text'
export const REFERRAL_DISCLOSURE_REWARD_TITLE =
  'referral_disclosure_reward_title'
export const REFERRAL_DISCLOSURE_REWARD_BODY = 'referral_disclosure_reward_body'
export const REFERRAL_DISCLOSURE_REWARD_BUTTON =
  'referral_disclosure_reward_button'
export const REFERRAL_SHARE_ICON = 'referral_share_icon'
export const REFERRAL_SHARE_LINK = 'referral_share_link'
export const REFERRAL_TERMS_MODAL = 'referral_terms_modal'
export const SHARE_THE_WEALTH_CARD = 'share_the_wealth_card'

export const LEARN_TIP = 'learn_tip'
export const MARKET_JUST_OPENED = 'market_just_opened'

export const SLIDER = 'slider'
export const HALFWAY = 'halfway'
export const TICK_ARRAY = 'tick_array'
export const WITHDRAWAL_AMOUNT = 'withdrawal_amount'
export const FEDERAL_TAX_PERCENTAGE = 'federal_tax_percentage'
export const FEDERAL_TAX_AMOUNT = 'federal_tax_amount'
export const STATE_TAX_PERCENTAGE = 'state_tax_percentage'
export const STATE_TAX_AMOUNT = 'state_tax_amount'
export const RECEIVE_AMOUNT = 'receive_amount'
export const WITHHOLDING_PERCENTAGE = 'withholding_percentage'

export const REFERRAL_FRIEND_HISTORY_HEADER = 'referral_friend_history_header'
export const REFERRAL_FRIEND_HISTORY_BODY = 'referral_friend_history_body'
export const REFERRAL_FRIEND_HISTORY_FRIEND = 'referral_friend_history_friend_'

export const REFERRAL_OFFER_SUBTITLE = 'referral_offer_subtitle'
export const REFERRAL_OFFER_FRIEND = 'referral_offer_friend_'

export const EMERGENCY_FUND_TRANSFER_MINI_BUTTON =
  'emergency_fund_transfer_mini_button'
export const EMERGENCY_FUND_TRANSFER_MODAL_DONE_BUTTON =
  'emergency_fund_transfer_modal_done_button'
export const EMERGENCY_FUND_TRANSFER_SUCCESS_PAGE_SUBHEADING =
  'emergency_fund_transfer_success_page_subheading'
export const EMERGENCY_FUND_CONFIRM_DRAWER_TRANSFER_BUTTON =
  'emergency_fund_confirm_drawer_transfer_button'
export const EMERGENCY_FUND_LOW_BALANCE_MODAL_REMAINING_BALANCE =
  'emergency_fund_low_balance_modal_remaining_balance'
export const EMERGENCY_SAVINGS_TRANSFER_CTA = 'emergency_savings_transfer_cta'

export const INTERSTITIAL_LAYOUT_FOOTER_PAUSE_BUTTON =
  'interstitial_layout_footer_pause_button'
export const INTERSTITIAL_LAYOUT_FOOTER_CONTINUE_BUTTON =
  'interstitial_layout_footer_continue_button'
export const INTERSTITIAL_LAYOUT_PAUSE_TITLE = 'interstitial_layout_pause_title'
export const INTERSTITIAL_LAYOUT_TITLE = 'interstitial_layout_title'
export const INTERSTITIAL_LAYOUT_BUTTON = 'interstitial_layout_button'

export const EARLY_POTENTIAL_UNPAUSE_FUNDING_SOURCE_CANCEL =
  'early_potential_unpause_funding_source_cancel'
export const EARLY_POTENTIAL_UNPAUSE_FUNDING_SOURCE_CONFIRM =
  'early_potential_unpause_funding_source_confirm'
export const EARLY_POTENTIAL_ERROR_TRY_AGAIN = 'early_potential_error_try_again'

export const NOTIFICATION_UNSUBSCRIBE_MODAL = 'notification_unsubscribe_modal'

export const EARLY_WITHDRAW_UNVERIFIED_FUNDING_SOURCE_HEADING =
  'early_withdraw_unverified_funding_source_heading'
export const EARLY_WITHDRAW_UNVERIFIED_FUNDING_SOURCE_VERIFY_BUTTON =
  'early_withdraw_unverified_funding_source_verify'
export const EARLY_WITHDRAW_ACTION_STRIP_TITLE =
  'early_withdraw_action_strip_title'
export const EARLY_WITHDRAW_ACTION_STRIP_SUBTEXT =
  'early_withdraw_action_strip_subtext'
export const EARLY_WITHDRAW_INTERSTITIAL_TITLE =
  'early_withdraw_interstitial_title'
export const WITHDRAWL_CONFIRM_MODAL_DISCLOSURE =
  'withdraw_confirm_modal_disclosure'

export const INVEST_RECURRING_UPDATE_BUTTON = 'invest_recurring_update_button'
export const INVEST_RECURRING_STOP_BUTTON = 'invest_recurring_stop_button'

export const LATER_RECURRING_STOP_RECURRING_SUCCESS_MODAL =
  'later_recurring_stop_recurring_success_modal'
export const LATER_RECURRING_UPDATE_BUTTON = 'later_recurring_update_button'
export const LATER_RECURRING_STOP_BUTTON = 'later_recurring_stop_button'
export const LATER_RECURRING_STOP_RECURRING_TURN_OFF_MODAL_BUTTON =
  'later_recurring_turn_off_modal_button'

export const EARLY_INITIAL_ONBOARDING_RECURRING_CONFIRM_MODAL =
  'early_initial_onboarding_recurring_confirm_modal'

export const RECURRING_SUCCESS_PAGE = 'recurring_success'

export const LATER_BENEFICIARY_SPOUSE_CTA = 'later_beneficiary_spouse_cta'
export const LATER_BENEFICIARY_NON_SPOUSE_CTA =
  'later_beneficiary_non_spouse_cta'
export const LATER_BENEFICIARY_SUBMIT_CTA = 'later_beneficiary_submit_cta'
export const LATER_BENEFICIARY_CHANGE_CTA = 'later_beneficiary_change_cta'
export const LATER_BENEFICIARY_SUBMITTED_MODAL_CTA =
  'later_beneficiary_submitted_modal_cta'

export const LATER_IRA_HELP_CTA = 'later_ira_help_cta'
export const LATER_ACCOUNT_NUMBER = 'later_account_number'
export const LATER_ACCOUNT_NAME = 'later_account_name'
export const LATER_MAX_CONTRIBUTION = 'later_max_contribution'
export const NET_INVESTMENT_BREAKDOWN = 'net_investment_breakdown'
export const TOTAL_GAIN_LOSS_BREAKDOWN = 'total_gain_loss_breakdown'
export const CASH_OWED_BREAKDOWN = 'cash_owed_breakdown'
export const TOTAL_ACCOUNT_VALUE_BREAKDOWN = 'total_account_value_breakdown'
export const LATER_CONTRIBUTION_CARD_RECURRING_OFF_CONTAINER =
  'later_contribution_card_recurring_off_container'
export const LATER_CONTRIBUTION_CARD_RECURRING_OFF_CTA =
  'later_contribution_card_recurring_off_cta'
export const LATER_CONTRIBUTION_LIMIT_HIT = 'later_contribution_limit_hit'
export const LATER_CONTRIBUTION_LIMIT_HIT_TITLE =
  'later_contribution_limit_hit_title'
export const LATER_CONTRIBUTION_LIMIT_HIT_YOU_DID_IT =
  'later_contribution_limit_hit_you_did_it'
export const LATER_CONTRIBUTION_PENDING_ACTIVITY =
  'later_contribution_pending_activity'
export const LATER_CONTRIBUTION_NOT_PENDING_OR_LIMIT_MET =
  'later_contribution_not_pending_or_limit_met'

export const ACCEPT_DOCS_LINK = 'accept_docs_link'
export const ACCEPT_DOCS_CTA = 'accept_docs_cta'

export const LOADING_SPINNER = 'loading_spinner'
export const LOADING_MESSAGE = 'loading_message'
export const PAGE_NOT_FOUND = 'page_not_found'

export const OFFER_TILE = 'offer_tile'

export const RECENT_ACTIVITY_WIDGET = 'recent_activity_card'
export const POTENTIAL_WIDGET = 'potential_card'
export const POTENTIAL_GRAPH_BAR_CONTAINER = 'potential_graph_bar_container'
export const RECURRING_LINK = 'recurring_link'

export const EARLY_MENU_ITEM_AGE_OF_TRANSFER_NOT_REACHED = 'early_menu_item'

export const ACTION_STRIP_SUBTEXT = 'action_strip_subtext'
export const ACTION_STRIP_TITLE = 'action_strip_title'

export const MAKE_INVESTMENT_NEXT_INVESTMENT_DATE =
  'make_investment_next_investment_date'

export const RECURRING_INVESTMENT_CANCELLABLE_INFO_NOTE_BUTTON =
  'recurring_investment_cancellable_info_note_button'
export const RECURRING_INVESTMENT_UNCANCELLABLE_INFO_NOTE_BUTTON =
  'recurring_investment_uncancellable_info_note_button'
export const DRAWER_CLOSE_BUTTON = 'drawer_close_button'

export const EARLY_RECAP_READY_WIDGET = 'early_recap_ready_widget'
export const EARLY_RECAP_READY_WIDGET_DISMISS =
  'early_recap_ready_widget_dismiss'
export const EARLY_RECAP_SETUP_WIDGET = 'early_recap_setup_widget'
export const EARLY_RECAP_UPGRADE_WIDGET = 'early_recap_upgrade_widget'
export const EARLY_RECAP_UPGRADE_WIDGET_CTA = 'early_recap_upgrade_widget_cta'
export const EARLY_RECAP_FAMILY_LANDER_CONTENT =
  'early_recap_family_lander_content'
export const EARLY_RECAP_UPGRADE_FAMILY_LANDER_DRAWER =
  'early_recap_upgrade_family_lander_drawer'
export const EARLY_RECAP_UPGRADE_FAMILY_LANDER_DRAWER_BANNER =
  'early_recap_upgrade_family_lander_drawer_banner'

export const EARLY_RECAP_SETUP_CONTENT_IMG = 'early_recap_setup_content_img'
export const EARLY_RECAP_SETUP_CTA_NEXT_BUTTON =
  'early_recap_setup_cta_next_button'
export const EARLY_RECAP_SETUP_CTA_LATER = 'early_recap_setup_cta_later'
export const EARLY_RECAP_SETUP_CONTENT_TITLE = 'early_recap_setup_content_title'
export const EARLY_RECAP_SETUP_CONTENT_SUBTITLE =
  'early_recap_setup_content_subtitle'
export const EARLY_RECAP_SETUP_CONTACT_INFO_SUBTITLE =
  'early_recap_setup_contact_info_subtitle'
export const EARLY_RECAP_SETUP_SUCCESS_TITLE = 'early_recap_setup_success_title'
export const EARLY_RECAP_SETUP_SUCCESS_SUBTITLE =
  'early_recap_setup_success_subtitle'

export const EARLY_RECAP_SHARE_SETTINGS_TITLE =
  'early_recap_share_settings_title'
export const EARLY_RECAP_SHARE_SETTINGS_SUBTITLE =
  'early_recap_share_settings_subtitle'

export const EARLY_SETTINGS_HEADER = 'early_settings_header'
export const EARLY_SETTINGS_ACCOUNT_DETAIL_ITEM =
  'early_settings_account_detail_item'
export const EARLY_SETTINGS_RECAP_BUTTON = 'early_settings_recap_button'

export const PAST_PAGE_CONTAINER = 'past_page_container'
export const PAST_BANNER = 'past_banner'
export const PAST_DETAILS_CONTAINER = 'past_details_container'

export const CASH_OWED_BUTTON = 'cash_owed_button'
export const CASH_OWED_BAR = 'cash_owed_bar'
export const CASH_OWED_DEBT_COLLECTION_CONTAINER =
  'cash_owed_debt_collection_container'
export const CASH_OWED_DEBT_COLLECTION_AMOUNT_REQUESTED =
  'cash_owed_debt_collection_amount_requested'
export const CASH_OWED_DEBT_COLLECTION_AMOUNT_COLLECTED =
  'cash_owed_debt_collection_amount_collected'
export const CASH_OWED_DISCLAIMER_TITLE = 'cash_owed_disclaimer_title'
export const CASH_OWED_DISCLAIMER_TEXT = 'cash_owed_disclaimer_text'
export const CASH_OWED_REINVESTMENT_CONTAINER =
  'cash_owed_reinvestment_container'
export const CASH_OWED_REINVESTMENT_AMOUNT = 'cash_owed_reinvestment_amount'
export const CASH_OWED_AMOUNT_COLLECTED_ITEM = 'cash_owed_amount_collected_item'
export const CASH_OWED_AMOUNT_COLLECTED_AMOUNT =
  'cash_owed_amount_collected_amount'

export const INVESTMENT_PICKER_BUTTON_VALUE = 'investment_picker_button_value_'

const nav = 'nav'
export const SIDE_BAR_CONTAINER = 'side_bar_container'
export const BOTTOM_BAR_CONTAINER = 'bottom_bar_container'
export const HOME_ICON = `${nav}_home_icon`
export const INVEST_HUB_ICON = `${nav}_invest_hub_icon`
export const BANKING_HUB_ICON = `${nav}_banking_hub_icon`
export const GROW_ICON = `${nav}_grow_icon`
export const EARN_ICON = `${nav}_earn_icon`

export const PRODUCT_ACCOUNT_CARDS = 'product_account_cards'

export const EARLY_POTENTIAL_EMPTY_USER_STATE_CONTAINER =
  'empty_user_state_container'

export const SIDEBAR_NAV_CONTAINER = 'sidebar_nav_wrapper'
export const SIDEBAR_CONTAINER = 'sidebar_container'
// this is being used for a button component that auto appends _button to the data testid
export const ADD_CHILD_BUTTON = 'add_child'
export const RERUN_SIDENAV_TOUR = 'rerun_sidenav_tour'
export const RERUN_SIDENAV_TOUR_BUTTON = 'rerun_sidenav_tour_button'
export const DISMISS_RERUN_SIDENAV_TOUR = 'learn_tip_close_button'

export const ACTION_FEED_FIRST_COLUMN = 'first_card_column'
export const ACTION_FEED_SECOND_COLUMN = 'second_card_column'
export const CHANGE_PRIMARY_CHECKING_TITLE = 'change_primary_checking_title'
export const CHANGE_PRIMARY_CHECKING_BUTTON = 'change_primary_checking'
export const CHANGE_PRIMARY_CHECKING_OPTION =
  'linked_accounts_page_primary_checking_option'
export const CHANGE_PRIMARY_CHECKING_CTA =
  'linked_accounts_page_update_primary_checking_next_cta'
export const CHANGE_PRIMARY_CHECKING_SUCCESS_BUTTON =
  'change_primary_checking_success'
export const CHANGE_PRIMARY_CHECKING_LINK_NEW_CTA =
  'linked_accounts_page_update_primary_checking_new_account_cta'
export const CHANGE_PRIMARY_CHECKING_MANUAL_CTA =
  'linked_accounts_page_link_manually_cta'
export const CHANGE_PRIMARY_CHECKING_MANUAL_LINK_ACCOUNT_CTA =
  'linked_accounts_link_account_button'

export const COMPARE_TIER_TITLE_CONTAINER = 'compare_tiers_title_container'
export const COMPARE_TIERS_NAME = 'compare_tiers_name'
export const COMPARE_TIERS_PRICING = 'compare_tiers_pricing'
export const COMPARE_TIERS_DESCRIPTION = 'compare_tiers_description'
export const COMPARE_TIERS_PILL_NAVIGATION = 'compare_tiers_pill_navigation'

export const CUSTOM_PORTFOLIO_LANDER_PAGE = 'lander_page'
export const REOPEN = {
  MESSAGE: 'reopen_message',
  CTA: 'reopen_acorns_cta',
}

export const HOME_DISCLOSURE_CONTENT = 'home_disclosure_content'
export const INVESTING_HUB_DISCLOSURE_CONTENT = 'investing_disclosure_content'
export const CHECKING_HOME_DISCLOSURE_CONTENT =
  'checking_home_disclosure_content'
export const LOGOUT_BUTTON = 'logout_button'
export const TO_REDEEM_GIFT_BUTTON = 'to_redeem_gift_button'
export const TO_MESSAGE_CENTER_BUTTON = 'to_message_center_button'
export const ACTION_FEED_FOOTER = 'action_feed_footer'

// button component appends `_button` to the end of this testId
export const IN_PROGRESS_FOOTER_BUTTON = 'in_progress_footer'
export const VERIFICATION_FOOTER_TEXT = 'verification_footer_text'
export const BANK_LINKING_PROGRESS_TRACKER = 'bank_linking_progress_tracker'
export const BANK_LINKING_INSTITUTION_INFO = 'bank_linking_institution_info'
export const FAMILY_INVESTING_VALUE_CONTAINER =
  'family_investing_value_container'
export const COMBINED_INVESTING_VALUE_CONTAINER =
  'combined_investing_value_container'
export const SINGLE_INVESTING_VALUE_CONTAINER =
  'single_investing_value_container'

export const SECURITY_TYPE_BREAKDOWN_CONTAINER =
  'security_type_breakdown_container'
export const STOCKS_BREAKDOWN_SECTION = 'Stocks_breakdown_section'
export const BONDS_BREAKDOWN_SECTION = 'Bonds_breakdown_section'
export const CRYPTO_BREAKDOWN_SECTION = 'Crypto_breakdown_section'
export const OPT_OUT_OF_TARGETING_TOGGLE =
  'settings_privacy_page_opt_out_of_targeting_toggle'

export const CANCEL_NAVIGATION_BUTTON = 'cancel_navigation_button'
export const NAVIGATE_ANYWAY_BUTTON = 'navgiate_anyway_button'

export const BENEFITS_HUB = 'benefits_hub'
export const BENEFITS_HUB_ERROR_RETRY = 'benefits_hub_error_retry'
export const BENEFITS_HUB_CARD = 'benefits_hub_card'
export const BENEFITS_HUB_CARD_LOADING = 'benefits_hub_card_loading'
export const BENEFITS_HUB_CARDS_CONTROLLER_TWO_CARDS =
  'benefits_hub_cards_controller_two_cards'
export const BENEFITS_HUB_CARD_STATUS_PILL = 'benefits_hub_card_status_pill'
export const BENEFITS_HUB_USER_DROPDOWN = 'benefits_hub_user_dropdown'
export const BENEFITS_HUB_DETAILS = 'benefits_hub_details'
export const BENEFITS_HUB_DETAILS_CONTACT_SUPPORT =
  'benefits_hub_details_contact_support'
export const BENEFITS_HUB_DETAILS_STATUS_STATE =
  'benefits_hub_details_status_state'
export const BENEFITS_HUB_TAX_FILING = 'benefits_hub_tax_filing'
export const BENEFITS_HUB_TAX_FILING_DEFAULT_HEADER =
  'benefits_hub_tax_filing_default_header'
export const BENEFITS_HUB_TAX_FILING_CTA = 'benefits_hub_tax_filing_cta'
export const BENEFITS_HUB_TAX_FILING_CTA_UPGRADE =
  'benefits_hub_tax_filing_cta_upgrade'
export const BENEFITS_HUB_TAX_FILING_DRAWER_START_FILING =
  'benefits_hub_tax_filing_drawer_start_filing'
export const BENEFITS_HUB_TAX_FILING_DRAWER_CLOSE =
  'benefits_hub_tax_filing_drawer_close'
export const BENEFITS_HUB_TAX_FILING_ENTRY_DISMISS =
  'benefits_hub_tax_filing_entry_dismiss'
export const BENEFITS_HUB_TAX_FILING_POTENTIAL_BOTTOM =
  'benefits_hub_tax_filing_potential_bottom'
export const BENEFITS_HUB_TAX_FILING_POTENTIAL_BAR =
  'benefits_hub_tax_filing_potential_bar'
export const BENEFITS_HUB_TAX_FILING_POTENTIAL_SLIDER =
  'benefits_hub_tax_filing_potential_slider'
export const BENEFITS_HUB_TAX_FILING_POTENTIAL_SLIDER_HANDLE =
  'benefits_hub_tax_filing_potential_slider_handle'

export const BENEFITS_HUB_LIFE_INSURANCE = 'benefits_hub_life_insurance'
export const BENEFITS_HUB_LIFE_INSURANCE_CTA = 'benefits_hub_life_insurance_cta'
export const BENEFITS_HUB_LIFE_INSURANCE_CONTACT_SUPPORT_HELP =
  'benefits_hub_life_insurance_contact_support_help'
export const BENEFITS_HUB_GOHENRY = 'benefits_hub_gohenry'
export const BENEFITS_HUB_GOHENRY_CTA = 'benefits_hub_gohenry_cta'
export const BENEFITS_HUB_COMPLIMENTARY_WILL = 'benefits_hub_complimentary_will'
export const BENEFITS_HUB_COMPLIMENTARY_WILL_CTA =
  'benefits_hub_complimentary_will_cta'
export const BENEFITS_HUB_UPGRADE_FLOW_COMPARE =
  'benefits_hub_upgrade_flow_compare'
export const BENEFITS_HUB_UPGRADE_FLOW_INTERIM_LANDER =
  'benefits_hub_upgrade_flow_interim_lander'
export const BENEFITS_HUB_UPGRADE_FLOW_INTERIM_CTA =
  'benefits_hub_upgrade_flow_interim_cta'
export const BENEFITS_HUB_UNVERIFIED_MODAL = 'benefits_hub_unverified_modal'
export const BENEFITS_HUB_UNVERIFIED_MODAL_TRIGGER =
  'benefits_hub_unverified_modal_trigger'

export const SETTINGS_LINKED_ACCOUNT_ALERT_ICON =
  'settings_linked_account_alert_icon'

export const GOHENRY_PREMIUM_ACTION_FEED_CARD =
  'gohenry_premium_action_feed_card'
export const GOHENRY_PREMIUM_CARD_BODY = 'gohenry_premium_card_body'
export const GOHENRY_UPGRADE_ACTION_FEED_CARD =
  'gohenry_upgrade_action_feed_card'
export const GOHENRY_UPGRADE_CARD_BODY = 'gohenry_upgrade_card_body'
export const GOHENRY_LEARN_MORE = 'gohenry_learn_more_button'
export const RESEND_VERIFICATION_DEPOSITS_CTA = 'resend_verification_depots_cta'
export const RESEND_VERIFICATION_DEPOSITS_CONFIRMATION_MODAL =
  'resend_verification_depots_confirmation_modal'
export const RESEND_VERIFICATION_DEPOSITS_CONFIRMATION_MODAL_CANCEL_CTA =
  'resend_verification_deposits_confirmation_modal_cancel_cta'
export const RESEND_VERIFICATION_DEPOSITS_CONFIRMATION_MODAL_RESEND_CTA =
  'resend_verification_deposits_confirmation_modal_resend_cta'
export const BANK_LINKING_SUCCESS_NEXT_CTA = 'bank_linking_success_next_cta'
export const TOOLTIP_INFO_CIRCLE = 'tooltip_info_circle'

export const CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_TEXT =
  'custom_portfolio_entry_point_card_text'
export const CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_ICON =
  'custom_portfolio_entry_point_card_icon'
export const CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_LINK =
  'custom_portfolio_entry_point_card_link'
export const CUSTOM_PORTFOLIO_ENTRY_POINT_CARD_DISMISS_BUTTON =
  'custom_portfolio_entry_point_card_dismiss_button'

export const FINANCIAL_ADVISOR_BUTTON = 'financial_advisor_button'

export const LEARN_HUB_ANDROID_STORE_CTA = 'learn_hub_android_store_cta'
export const LEARN_HUB_APPLE_STORE_CTA = 'learn_hub_apple_store_cta'
export const LEARN_HUB_QR_CODE = 'learn_hub_qr_code'
export const LEARN_HUB_MOBILE_IMAGE = 'learn_hub_mobile_image'
export const LEARN_HUB_HEADER = 'learn_hub_header'
export const LEARN_HUB_DESCRIPTION = 'learn_hub_description'

export const CUSTOM_PORTFOLIO_TOURTIP = 'custom_portfolio_tourtip'
export const EARN_HOLIDAY_CHROME_EXTENSION_TOUR_TIP =
  'earn_holiday_chrome_extension_tour_tip'
export const EARN_HOLIDAY_CHROME_EXTENSION_TOUR_TIP_CTA =
  'earn_holiday_chrome_extension_tour_tip_cta'
export const EARN_HOLIDAY_CHROME_EXTENSION_TOUR_TIP_DISMISSED =
  'earn_holiday_chrome_extension_tour_tip_dismissed'

export const AI_ASSISTANT_DESKTOP_TOGGLE_BUTTON =
  'ai_assistant_desktop_toggle_button'
export const AI_ASSISTANT_INVERTED_ICON = 'ai_assistant_inverted_icon'
export const AI_ASSISTANT_INVERTED_ICON_SCROLLED =
  'ai_assistant_inverted_icon_scrolled'
export const BANKING_HUB_LAST_30_DAYS_DEPOSITED =
  'banking_hub_last_30_days_deposited'
export const BANKING_HUB_LAST_30_DAYS_SPENT = 'banking_hub_last_30_days_spent'
export const BANKING_HUB_DISCLOSURE_CONTENT = 'banking_hub_disclosure_content'
export const EMERGENCY_FUND_DISCLOSURE_CONTENT =
  'emergency_fund_disclosure_content'

export const CHECKING_CONFIRM_TRANSFER_FREQUENCY_ETA =
  'checking_confirm_transfer_frequency_eta'
export const CHECKING_TRANSFER_SUCCESS_ETA = 'checking_transfer_success_eta'
export const CHECKING_LANDING_PAGE_SPINNER = 'checking_landing_page_spinner'

export const PENDING_TRANSFERS_OPEN_CTA = 'pending_transfers_open_cta'

export const EARN_TOUR_INTERSTITIAL = 'earn_tour_interstitial'
export const PENDING_TRANSFER_CTA = 'pending_transfer_cta'

export const ROUNDUPS_WIDGET_SUBTITLE = 'roundups_widget_subtitle'
export const ROUNDUPS_WIDGET_BUTTON = 'roundups_widget_button'

export const EARN_EXTENSION_CARD = 'earn_extension_card'

export const DRAWER = 'drawer'
export const PILL = 'pill'

export const SKIP_BUTTON = 'skip_button'

export const AI_CHAT_INPUT = 'ai_chat_input'
export const AI_CHAT_SEND_CTA = 'ai_chat_send_cta'
export const AI_CHAT_USER_SENT_MESSAGE = 'ai_chat_user_sent_message'
export const AI_CHAT_RESPONSE_MESSAGE = 'ai_chat_response_message'
export const AI_ASSISTANT_RATING_CONTAINER = 'ai_assistant_rating_container'
export const AI_ASSISTANT_RATING_THUMBS_UP = 'ai_assistant_rating_thumbs_up'
export const AI_ASSISTANT_RATING_THUMBS_DOWN = 'ai_assistant_rating_thumbs_down'
export const AI_ASSISTANT_TYPING_DOTS = 'ai_assistant_typing_dots'
export const AI_ASSISTANT_COPY_ICON = 'ai_assistant_copy_icon'
export const AI_ASSISTANT_CONTAINER = 'ai_assistant_container'
export const CHAT_WIDGET_CTA_CONTAINER = 'ai_assistant_chat_widget_container'
export const AI_ASSISTANT_MINIMIZE_BUTTON = 'ai_assistant_minimize_button'
export const AI_ASSISTANT_EXPAND_BUTTON = 'ai_assistant_expand_button'
export const AI_ASSISTANT_CLOSE_BUTTON = 'ai_assistant_close_button'

export const MONEY_MANAGER_QR_CODE_CONTAINER = 'money_manager_qr_code_container'
export const MONEY_MANAGER_IOS_APP_STORE_LINK =
  'money_manager_ios_app_store_link'
export const MONEY_MANAGER_ANDROID_APP_STORE_LINK =
  'money_manager_android_app_store_link'

export const ESG_PORTFOLIO_REMOVAL_DRAWER_CONFIRM_CTA =
  'esg-portfolio-removal-drawer-confirm-cta'

export const PUBLISHING_RECAP_PAGE = 'publishing_recap_page'

export const LOADING_PAGE = 'recap_loading_page'
export const ERROR_PAGE = 'recap_error_page'
export const LINK_EXPIRED_PAGE = 'recap_link_expired_page'

export const TITLE_BAR_CLOSE_BUTTON = 'title_bar_close_button'
export const TITLE_BAR_SHARE_BUTTON = 'title_bar_share_button'
export const TITLE_BAR_MOBILE_CLOSE_BUTTON = 'title_bar_mobile_close_button'
export const TITLE_BAR_MOBILE_SHARE_BUTTON = 'title_bar_mobile_share_button'

export const RECAP_INTRO_SECTION = 'recap_intro_section'
export const INTRO_SCROLL_BUTTON = 'intro_scroll_button'

export const GIFTS_SECTION = 'gifts_section'
export const GIFTS_DETAIL_CONTAINER = 'gifts_detail_container'
export const GIFTS_INTERACTIVE_CONTAINER = 'gifts_interactive_container'
export const GIFTS_DETAIL_NO_GIFTS_TITLE = 'gifts_detail_no_gifts_title'
export const GIFTS_DETAIL_NO_GIFTS_BUTTON = 'gifts_detail_no_gifts_button'
export const GIFTS_DETAIL_HAS_GIFTS_TITLE = 'gifts_detail_has_gifts_title'
export const GIFTS_BACKDROP_OVERLAY = 'gifts_backdrop_overlay'
export const GIFTS_INTERACTIVE_SQUIRREL_ICON = 'gifts_interactive_squirrel_icon'
export const GIFTS_INTERACTIVE_GIFT_TOOLTIP = 'gifts_interactive_gift_tooltip'

export const TABLE_OF_CONTENT_SECTION = 'table_of_content_section'
export const TABLE_OF_CONTENT_TITLE = 'table_of_content_title'
export const TABLE_OF_CONTENT_GROW_LEAF_TIP = 'table_of_content_grow_leaf_tip'
export const TABLE_OF_CONTENT_GROW_LEAF_CAROUSEL =
  'table_of_content_grow_leaf_carousel'
export const TABLE_OF_CONTENT_GROW_LEAF_CARD = 'table_of_content_grow_leaf_card'

export const SCROLL_WRAPPER = 'scroll_wrapper'
export const SCROLL_WRAPPER_THUMB = 'scroll_wrapper_thumb'
export const SCROLL_WRAPPER_TRACK = 'scroll_wrapper_track'

export const CONTRIBUTIONS_CONTENT = 'contributions_content'
export const CONTRIBUTIONS_DETAILS = 'contributions_details'
export const CONTRIBUTIONS_SECTION = 'contributions_section'

export const PERFORMANCE_CHART = 'performance_chart'
export const PERFORMANCE_CHART_LABEL = 'performance_chart_label'
export const PERFORMANCE_CONTENT = 'performance_content'
export const PERFORMANCE_DETAILS = 'performance_details'
export const PERFORMANCE_GAIN_LOSS = 'performance_gain_loss'
export const PERFORMANCE_SECTION = 'performance_section'
export const PERFORMANCE_TOGGLE = 'performance_toggle'
export const PERFORMANCE_TOOLTIP = 'performance_tooltip'
export const PERFORMANCE_STICK_WITH_IT_MODAL = 'performance_stick_with_it_modal'

export const POTENTIAL_CONTENT = 'potential_content'
export const POTENTIAL_DETAILS = 'potential_details'
export const POTENTIAL_SECTION = 'potential_section'
export const POTENTIAL_DISCLOSURE_LINK = 'potential_disclosure_link'

export const SECTION_ICON_CONTAINER = 'section_icon_container'

export const GROW_BUTTON = 'grow_button'

export const ARTICLE_BUTTON = 'article_button'
export const ARTICLE_SUBHEADER = 'article_subheader'
export const ARTICLE_PARAGRAPH = 'article_paragraph'
export const ARTICLE_LIST = 'article_list'
export const ARTICLE_BACK_BUTTON = 'article_back_button'
export const ARTICLE_NO_ARTICLE = 'article_no_article'

export const ENABLE_SHARING_MODAL = 'enable_sharing_modal'
export const DESKTOP_SHARING_MODAL = 'desktop_sharing_modal'
export const MOBILE_SHARE_BUTTON = 'mobile_share_button'
export const PROFILE_AND_SETTINGS = 'profile_and_settings'
export const HERO_BANNER_CONTENT = 'hero_banner_content'

export const earnRecentActivityReward = (status: string) =>
  `earn_recent_activity_${status}_reward`
export const earnRecentActivityInfoCta = (status: string) =>
  `earn_recent_activity_${status}_info_cta`
export const earnRecentActivityInvestmentsContainer = (status: string) =>
  `earn_recent_activity_${status}_investments_container`
export const earnRecentActivityRewardsInfoDrawer = (status: string) =>
  `earn_recent_activity_${status}_rewards_info_drawer`
